<template>
  <div>
    <div class="card">
      <div class="card-header bg-success pt-0">
        <!-- Botón de filtros móviles - SIEMPRE ARRIBA -->
        <div class="d-md-none mb-2">
          <button
            class="btn btn-info btn-sm rounded-pill btn-filter--border w-100"
            type="button"
            @click="showMobileFilters = !showMobileFilters"
          >
            <i class="fa fa-sliders me-2" aria-hidden="true"></i>
            {{ showMobileFilters ? 'Ocultar Filtros' : 'Mostrar Filtros' }}
          </button>
        </div>
        
        <!-- Filtros de escritorio - SIEMPRE VISIBLES EN ESCRITORIO -->
        <div class="d-none d-md-block">
          <!-- Primera fila: Búsqueda General, Fecha Desde, Fecha Hasta -->
        <div class="row mb-1">
          <div class="col-md-3 mb-1 filter-field">
            <label class="form-label small text-light mb-1 d-block">
              <i class="fas fa-search me-1"></i> Búsqueda general
            </label>
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="Responsable, caja o usuario"
              v-model="filters.searchTerm"
              @keyup.enter="handleSearch"
            />
          </div>
          <div class="col-md-3 mb-1 filter-field">
            <label class="form-label small text-light mb-1 d-block">
              <i class="fas fa-calendar-alt me-1"></i> Fecha desde
            </label>
            <input
              type="date"
              class="form-control form-control-sm"
              v-model="filters.dateFrom"
              :max="filters.dateTo || getTodayDate()"
            />
          </div>
          <div class="col-md-3 mb-1 filter-field">
            <label class="form-label small text-light mb-1 d-block">
              <i class="fas fa-calendar-check me-1"></i> Fecha hasta
            </label>
            <input
              type="date"
              class="form-control form-control-sm"
              v-model="filters.dateTo"
              :min="filters.dateFrom"
              :max="getTodayDate()"
            />
          </div>

        </div>
        
        <!-- Segunda fila: Sucursal, Caja, y Botones -->
        <div class="row mb-1">
          <div class="col-md-3 mb-1 filter-field">
            <label class="form-label small text-light mb-1 d-block">
              <i class="fas fa-building me-1"></i> Sucursal
            </label>
            <select 
              class="form-select form-select-sm" 
              v-model="filters.branch"
            >
              <option value="">Todas las sucursales</option>
              <option 
                v-for="branch in branches" 
                :key="branch._id || branch.id || branch" 
                :value="branch._id || branch.id || branch"
              >
                {{ branch.nombreSucursal || branch.nombre || branch }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mb-1 filter-field">
            <label class="form-label small text-light mb-1 d-block">
              <i class="fas fa-cash-register me-1"></i> Caja
            </label>
            <select 
              class="form-select form-select-sm" 
              v-model="filters.cashier"
            >
              <option value="">Todas las cajas</option>
              <option 
                v-for="n in 15" 
                :key="n" 
                :value="`CAJA ${n}`"
              >
                CAJA {{ n }}
              </option>
            </select>
          </div>
          <div class="col-md-6 mb-1">
            <div class="d-flex justify-content-end align-items-end h-100">
              <button
                class="btn btn-info btn-sm rounded-pill btn-filter--border text-nowrap me-2"
                type="button"
                @click="handleSearch"
                :disabled="loading || isSearching"
              >
                <i v-if="isSearching" class="fas fa-spinner fa-spin me-1"></i>
                <i v-else class="fa fa-search me-1" aria-hidden="true"></i>
                {{ isSearching ? 'Buscando...' : 'Buscar' }}
              </button>
              
              <button
                class="btn btn-success btn-sm btn-filter--border"
                type="button"
                @click="exportRecords"
                :disabled="loading || isExporting || records.length === 0"
                title="Exportar a Excel"
              >
                <i v-if="isExporting" class="fas fa-spinner fa-spin" aria-hidden="true"></i>
                <i v-else class="fa fa-file-excel" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
        
          <!-- Botones de paneles -->
          <div class="d-flex justify-content-center pt-2 border-top border-light border-opacity-25">
            <div class="btn-group" role="group">
              <button 
                type="button" 
                class="btn btn-sm rounded-pill btn-filter--border text-nowrap panel-toggle-btn"
                :class="{ 'active': showChartsPanel }"
                @click="toggleChartsPanel"
                title="Mostrar/Ocultar gráficos"
              >
                <i class="fas fa-chart-bar me-2"></i>
                Gráficos
              </button>
                
              <button 
                type="button" 
                class="btn btn-sm rounded-pill btn-filter--border mx-2 text-nowrap panel-toggle-btn"
                :class="{ 'active': showSavedFilters }"
                @click="toggleSavedFilters"
                title="Mostrar/Ocultar filtros guardados"
              >
                <i class="fas fa-bookmark me-2"></i>
                Guardados
              </button>
            </div>
          </div>
        </div>
      
      <!-- Panel de filtros móviles -->
      <div v-if="showMobileFilters" class="d-md-none mobile-filters mx-3 mt-2">
          <div class="mb-3">
            <label class="form-label small text-white fw-bold mb-1 d-block" for="searchTextMobileCash">
              <i class="fas fa-search me-1"></i>Búsqueda general
            </label>
            <input
              id="searchTextMobileCash"
              type="text"
              class="form-control form-control-sm"
              placeholder="Responsable, caja o usuario"
              v-model="filters.searchTerm"
              @keyup.enter="handleSearch"
            />
          </div>
          
          <div class="row mb-3">
            <div class="col-6 pe-2">
              <label class="form-label small text-white fw-bold mb-1 d-block" for="dateFromMobileCash">
                <i class="fas fa-calendar-alt me-1"></i>Fecha desde
              </label>
              <input
                id="dateFromMobileCash"
                type="date"
                class="form-control form-control-sm"
                v-model="filters.dateFrom"
                :max="filters.dateTo || getTodayDate()"
              />
            </div>
            <div class="col-6 ps-2">
              <label class="form-label small text-white fw-bold mb-1 d-block" for="dateToMobileCash">
                <i class="fas fa-calendar-check me-1"></i>Fecha hasta
              </label>
              <input
                id="dateToMobileCash"
                type="date"
                class="form-control form-control-sm"
                v-model="filters.dateTo"
                :min="filters.dateFrom"
                :max="getTodayDate()"
              />
            </div>
          </div>
          
          <div class="row mb-3">
            <div class="col-6 pe-2">
              <label class="form-label small text-white fw-bold mb-1 d-block" for="branchMobileCash">
                <i class="fas fa-building me-1"></i>Sucursal
              </label>
              <select 
                id="branchMobileCash"
                class="form-select form-select-sm" 
                v-model="filters.branch"
              >
                <option value="">Todas las sucursales</option>
                <option 
                  v-for="branch in branches" 
                  :key="branch._id || branch.id || branch" 
                  :value="branch._id || branch.id || branch"
                >
                  {{ branch.nombreSucursal || branch.nombre || branch }}
                </option>
              </select>
            </div>
            <div class="col-6 ps-2">
              <label class="form-label small text-white fw-bold mb-1 d-block" for="cashierMobileCash">
                <i class="fas fa-cash-register me-1"></i>Caja
              </label>
              <select 
                id="cashierMobileCash"
                class="form-select form-select-sm" 
                v-model="filters.cashier"
              >
                <option value="">Todas las cajas</option>
                <option 
                  v-for="n in 15" 
                  :key="n" 
                  :value="`CAJA ${n}`"
                >
                  CAJA {{ n }}
                </option>
              </select>
            </div>
          </div>
          
          <!-- Botones de panel en mobile -->
          <div class="btn-group btn-group-sm w-100 mb-2" role="group">
            <button 
              type="button" 
              class="btn btn-sm btn-filter--border panel-toggle-btn mobile-btn-consistent"
              :class="{ 'active': showChartsPanel }"
              @click="toggleChartsPanel"
            >
              <i class="fas fa-chart-bar me-1" aria-hidden="true"></i>
              Gráficos
            </button>
            <button 
              type="button" 
              class="btn btn-sm btn-filter--border panel-toggle-btn mobile-btn-consistent"
              :class="{ 'active': showSavedFilters }"
              @click="toggleSavedFilters"
            >
              <i class="fas fa-bookmark me-1" aria-hidden="true"></i>
              Guardados
            </button>
          </div>
          
          <!-- Botones de búsqueda y exportación móvil -->
          <div class="btn-group btn-group-sm w-100 mt-2" role="group">
            <button 
              type="button" 
              class="btn btn-sm btn-info btn-filter--border mobile-btn-consistent"
              @click="handleSearch"
              :disabled="loading || isSearching"
            >
              <i v-if="isSearching" class="fas fa-spinner fa-spin me-1"></i>
              <i v-else class="fa fa-search me-1" aria-hidden="true"></i>
              {{ isSearching ? 'Buscando...' : 'Buscar' }}
            </button>
            <button 
              type="button" 
              class="btn btn-sm btn-success btn-filter--border mobile-btn-consistent"
              @click="exportRecords"
              :disabled="loading || isExporting || records.length === 0"
              title="Exportar a Excel"
            >
              <i v-if="isExporting" class="fas fa-spinner fa-spin me-1"></i>
              <i v-else class="fa fa-file-excel me-1" aria-hidden="true"></i>
              Excel
            </button>
          </div>
        </div>
      </div>

      <div class="card-body pt-2">
        <!-- Panel de KPIs -->
        <div v-if="showKPIs && metrics && Object.keys(metrics).length > 0" class="card mb-3 bg-light" ref="kpisSection">
          <div class="card-body">
            <div class="row text-center">
              <div class="col-lg-3 col-md-6 mb-3 mb-lg-0">
                <div class="d-flex align-items-center justify-content-center">
                  <div class="icon-shape bg-primary text-white rounded-circle me-3">
                    <i class="fas fa-file-invoice"></i>
                  </div>
                  <div>
                    <h5 class="mb-0 text-primary">{{ metrics.totalCierres || 0 }}</h5>
                    <small class="text-muted">Total Cierres</small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 mb-3 mb-lg-0">
                <div class="d-flex align-items-center justify-content-center">
                  <div class="icon-shape bg-success text-white rounded-circle me-3">
                    <i class="fas fa-dollar-sign"></i>
                  </div>
                  <div>
                    <h5 class="mb-0 text-success">${{ formatMoney(metrics.totalVentasSistema || 0) }}</h5>
                    <small class="text-muted">Total Sistema</small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 mb-3 mb-md-0">
                <div class="d-flex align-items-center justify-content-center">
                  <div class="icon-shape bg-info text-white rounded-circle me-3">
                    <i class="fas fa-check-double"></i>
                  </div>
                  <div>
                    <h5 class="mb-0 text-info">${{ formatMoney(metrics.totalVentasRatificadas || 0) }}</h5>
                    <small class="text-muted">Total Ratificado</small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-center justify-content-center">
                  <div class="icon-shape bg-warning text-white rounded-circle me-3">
                    <i class="fas fa-exclamation-triangle"></i>
                  </div>
                  <div>
                    <h5 class="mb-0 text-warning">{{ metrics.cierresConDiferencias || 0 }}</h5>
                    <small class="text-muted">Con Diferencias</small>
                  </div>
                </div>
              </div>
            </div>
            <!-- Información adicional -->
            <div class="row mt-3 pt-3 border-top">
              <div class="col-md-3 text-center">
                <small class="text-muted">
                  <i class="fas fa-percentage me-1"></i>
                  Con diferencias: <strong>{{ metrics.porcentajeCierresConDiferencias || 0 }}%</strong>
                </small>
              </div>
              <div class="col-md-3 text-center">
                <small class="text-muted">
                  <i class="fas fa-chart-line me-1"></i>
                  Promedio diferencia: <strong>${{ formatMoney(metrics.promedioDiferencia || 0) }}</strong>
                </small>
              </div>
              <div class="col-md-3 text-center">
                <small class="text-muted">
                  <i class="fas fa-arrow-up me-1"></i>
                  Total sobrantes: <strong>${{ formatMoney(metrics.totalSobrantes || 0) }}</strong>
                </small>
              </div>
              <div class="col-md-3 text-center">
                <small class="text-muted">
                  <i class="fas fa-arrow-down me-1"></i>
                  Total faltantes: <strong>${{ formatMoney(metrics.totalFaltantes || 0) }}</strong>
                </small>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel de Gráficos -->
        <div v-if="showChartsPanel" class="card mb-3 border-warning" ref="chartsPanel">
          <div class="card-header bg-warning text-dark">
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="mb-0">
                <i class="fas fa-chart-bar me-2"></i>
                Análisis Visual de Cierres de Caja
                <small class="text-muted ms-2" v-if="metrics && metrics.periodo">
                  {{ metrics.periodo.descripcion }}
                </small>
              </h6>
              <div class="d-flex gap-2">
                <button 
                  type="button" 
                  class="btn btn-sm btn-export-pdf"
                  @click="exportChartsToPDF"
                  title="Exportar gráficos a PDF"
                  :disabled="loading || isExportingPDF"
                >
                  <i v-if="isExportingPDF" class="fas fa-spinner fa-spin me-1"></i>
                  <i v-else class="fas fa-file-pdf me-1"></i>
                  {{ isExportingPDF ? 'Exportando...' : 'EXPORTAR PDF' }}
                </button>
                <button 
                  type="button" 
                  class="btn btn-sm btn-dark"
                  @click="showChartsPanel = false"
                >
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <!-- Primera fila de gráficos -->
            <div class="row">
              <!-- Gráfico de Métodos de Pago -->
              <div class="col-lg-6 mb-4">
                <h6 class="text-muted mb-3">
                  <i class="fas fa-chart-pie me-2"></i>
                  Distribución por Método de Pago
                </h6>
                <div class="chart-container" style="height: 300px; position: relative;">
                  <canvas ref="paymentMethodChart"></canvas>
                </div>
              </div>
              <!-- Gráfico de Estado de Cierres -->
              <div class="col-lg-6 mb-4">
                <h6 class="text-muted mb-3">
                  <i class="fas fa-chart-doughnut me-2"></i>
                  Estado de Cierres
                </h6>
                <div class="chart-container" style="height: 300px; position: relative;">
                  <canvas ref="closureStatusChart"></canvas>
                </div>
              </div>
            </div>
            
            <!-- Segunda fila de gráficos -->
            <div class="row">
              <!-- Gráfico de Top Sucursales -->
              <div class="col-lg-6 mb-4">
                <h6 class="text-muted mb-3">
                  <i class="fas fa-chart-bar me-2"></i>
                  Top Sucursales por Diferencias
                </h6>
                <div class="chart-container" style="height: 300px; position: relative;">
                  <canvas ref="branchDifferencesChart"></canvas>
                </div>
              </div>
              <!-- Gráfico de Comparación Sistema vs Ratificado -->
              <div class="col-lg-6 mb-4">
                <h6 class="text-muted mb-3">
                  <i class="fas fa-balance-scale me-2"></i>
                  Comparación Sistema vs Ratificado
                </h6>
                <div class="chart-container" style="height: 300px; position: relative;">
                  <canvas ref="systemVsVerifiedChart"></canvas>
                </div>
              </div>
            </div>
            
            <!-- Tercera fila de gráficos -->
            <div class="row">
              <!-- Gráfico de Diferencias Detalladas -->
              <div class="col-lg-6 mb-4">
                <h6 class="text-muted mb-3">
                  <i class="fas fa-chart-line me-2"></i>
                  Análisis de Diferencias
                </h6>
                <div class="chart-container" style="height: 300px; position: relative;">
                  <canvas ref="differencesAnalysisChart"></canvas>
                </div>
              </div>
              <!-- Gráfico de Resumen por Sucursal -->
              <div class="col-lg-6 mb-4">
                <h6 class="text-muted mb-3">
                  <i class="fas fa-chart-area me-2"></i>
                  Resumen Detallado por Sucursal
                </h6>
                <div class="chart-container" style="height: 300px; position: relative;">
                  <canvas ref="branchDetailChart"></canvas>
                </div>
              </div>
            </div>
            
            <!-- Indicadores adicionales -->
            <div class="row mt-3">
              <div class="col-12">
                <div class="alert alert-info mb-0">
                  <div class="row text-center">
                    <div class="col-md-3">
                      <strong>Mayor Diferencia:</strong><br>
                      <span class="h5 mb-0">${{ formatMoney(metrics.mayorDiferencia || 0) }}</span>
                    </div>
                    <div class="col-md-3">
                      <strong>Caja Inicial Total:</strong><br>
                      <span class="h5 mb-0">${{ formatMoney(metrics.totalCajaInicial || 0) }}</span>
                    </div>
                    <div class="col-md-3">
                      <strong>Suma Diferencias Absolutas:</strong><br>
                      <span class="h5 mb-0">${{ formatMoney(metrics.sumaDiferenciasAbsolutas || 0) }}</span>
                    </div>
                    <div class="col-md-3">
                      <strong>Total Diferencias:</strong><br>
                      <span class="h5 mb-0">${{ formatMoney(metrics.totalDiferencias || 0) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel de Filtros Guardados -->
        <div v-if="showSavedFilters" class="card mb-3 border-info">
          <div class="card-header text-white" style="background-color: #66C4DE; padding: 0.375rem 1rem;">
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="mb-0">
                <i class="fas fa-bookmark me-2"></i>
                FILTROS GUARDADOS - CIERRES DE CAJA
              </h6>
              <div class="d-flex">
                <button 
                  type="button" 
                  class="btn btn-sm btn-secondary me-2"
                  @click="openSaveFilterModal"
                  title="Guardar filtro actual"
                >
                  <i class="fas fa-save me-1"></i>
                  GUARDAR ACTUAL
                </button>
                <button 
                  type="button" 
                  class="btn btn-sm btn-secondary"
                  @click="showSavedFilters = false"
                  title="Cerrar panel"
                >
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div v-if="sortedSavedFilters.length === 0" class="text-center py-4">
              <div class="empty-state">
                <i class="fas fa-bookmark fa-3x mb-3 text-muted"></i>
                <h5 class="text-dark mb-2">📁 No hay filtros guardados</h5>
                <p class="text-muted mb-3">
                  ¡Optimiza tu trabajo guardando configuraciones de filtros frecuentes!
                </p>
                <div class="alert alert-info mb-4" style="background-color: #E3F2FD; border-color: #66C4DE;">
                  <h6 class="alert-heading text-primary mb-3">
                    <i class="fas fa-lightbulb me-2"></i>
                    ¿CÓMO USAR LOS FILTROS GUARDADOS?
                  </h6>
                  <ol class="mb-0 text-start text-dark">
                    <li class="mb-2">Configura tus filtros favoritos (fechas, sucursal, caja, etc.)</li>
                    <li class="mb-2">Haz clic en <span class="badge bg-secondary">GUARDAR ACTUAL</span></li>
                    <li class="mb-2">Dale un nombre descriptivo a tu filtro</li>
                    <li>Úsalo cuando lo necesites con un solo clic</li>
                  </ol>
                </div>
                <button 
                  type="button" 
                  class="btn btn-info btn-sm text-white"
                  @click="openSaveFilterModal"
                  style="background-color: #66C4DE; border-color: #66C4DE;"
                >
                  <i class="fas fa-plus me-2"></i>
                  CREAR MI PRIMER FILTRO
                </button>
              </div>
            </div>
            <div v-else class="row">
              <div 
                v-for="filter in sortedSavedFilters" 
                :key="filter.id" 
                class="col-lg-4 col-md-6 col-xl-3 mb-3"
              >
                <div class="card border-light h-100 saved-filter-card">
                  <div class="card-header bg-light" style="padding: 0.375rem 0.75rem;">
                    <h6 class="mb-0 text-truncate text-dark" :title="filter.name">{{ filter.name }}</h6>
                  </div>
                  <div class="card-body" style="padding: 0.75rem;">
                    <p class="small text-muted mb-2">{{ filter.description || 'Sin descripción' }}</p>
                    
                    <!-- Detalles del filtro -->
                    <div class="filter-details mb-3">
                      <div class="badge-container mb-2">
                        <span v-if="filter.filters.searchTerm" class="badge bg-secondary badge-sm me-1 mb-1">
                          <i class="fas fa-search fa-xs me-1"></i>{{ filter.filters.searchTerm }}
                        </span>
                        <span v-if="filter.filters.branch" class="badge badge-sm me-1 mb-1" style="background-color: #66C4DE; color: white;">
                          <i class="fas fa-building fa-xs me-1"></i>{{ getBranchName(filter.filters.branch) }}
                        </span>
                        <span v-if="filter.filters.cashier" class="badge badge-sm me-1 mb-1" style="background-color: #FFA726; color: white;">
                          <i class="fas fa-cash-register fa-xs me-1"></i>{{ filter.filters.cashier }}
                        </span>
                      </div>
                      
                      <!-- Rango de fechas -->
                      <div v-if="filter.filters.dateFrom || filter.filters.dateTo" class="date-range-info small text-muted">
                        <i class="fas fa-calendar-alt me-1"></i>
                        <span v-if="filter.filters.dateFrom && filter.filters.dateTo">
                          {{ formatDateForDisplay(filter.filters.dateFrom) }} - {{ formatDateForDisplay(filter.filters.dateTo) }}
                        </span>
                        <span v-else-if="filter.filters.dateFrom">
                          Desde {{ formatDateForDisplay(filter.filters.dateFrom) }}
                        </span>
                        <span v-else>
                          Hasta {{ formatDateForDisplay(filter.filters.dateTo) }}
                        </span>
                      </div>
                      
                      <!-- Fecha de creación -->
                      <div class="creation-date small text-muted mt-2">
                        <i class="fas fa-clock me-1"></i>
                        Creado {{ getRelativeTime(filter.createdAt) }}
                      </div>
                    </div>
                    
                    <!-- Botones de acción -->
                    <div class="d-grid gap-2">
                      <!-- Botón principal: Aplicar filtro -->
                      <button 
                        type="button" 
                        class="btn btn-sm text-white"
                        @click="applySavedFilter(filter)"
                        title="Aplicar este filtro"
                        style="background-color: #66C4DE; border-color: #66C4DE;"
                      >
                        <i class="fas fa-play me-2"></i>
                        Aplicar Filtro
                      </button>
                      
                      <!-- Botones secundarios -->
                      <div class="btn-group" role="group">
                        <button 
                          type="button" 
                          class="btn btn-outline-info btn-sm"
                          @click="editSavedFilter(filter)"
                          title="Editar filtro"
                        >
                          <i class="fas fa-edit me-1"></i>
                          Editar
                        </button>
                        <button 
                          type="button" 
                          class="btn btn-outline-success btn-sm"
                          @click="duplicateSavedFilter(filter)"
                          title="Duplicar filtro"
                        >
                          <i class="fas fa-copy me-1"></i>
                          Copiar
                        </button>
                        <button 
                          type="button" 
                          class="btn btn-outline-danger btn-sm"
                          @click="deleteSavedFilter(filter)"
                          title="Eliminar filtro"
                        >
                          <i class="fas fa-trash me-1"></i>
                          Eliminar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-muted small mb-2">
          <span v-if="loading">Cargando...</span>
          <span v-else>
            Mostrando {{ records.length }} de {{ totalRecords }} registros
          </span>
        </div>

        <div class="table-responsive">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th class="caja-column">Caja</th>
                <th>Responsable</th>
                <th>Sucursal</th>
                <th>Fecha Cierre</th>
                <th>Total Sistema</th>
                <th>Total Ratificado</th>
                <th>Diferencia</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="8" class="text-center py-4">
                  Cargando...
                </td>
              </tr>
              <tr v-else-if="records.length === 0">
                <td colspan="8" class="text-center py-4 text-muted">
                  No se encontraron cierres de caja
                </td>
              </tr>
              <template v-else>
                <tr v-for="record in records" :key="record._id">
                <td class="caja-column">{{ record.caja }}</td>
                <td>{{ record.responsable || 'Sin responsable' }}</td>
                <td>{{ record.nombreSucursal || 'Sin sucursal' }}</td>
                <td>{{ formatDate(record.fechaCierre) }}</td>
                <td>
                  ${{
                    formatMoney(
                      (record.totalSistema && record.totalSistema.ventasTotales) || 0
                    )
                  }}
                </td>
                <td>
                  ${{
                    formatMoney(
                      (record.totalRatificado && record.totalRatificado.ventasTotales) || 0
                    )
                  }}
                </td>
                <td>
                  ${{
                    formatMoney(
                      Math.abs(
                        (record.totalRatificado && record.totalRatificado.totalDiferencia) || 0
                      )
                    )
                  }}
                </td>
                <td>
                  <div class="btn-group btn-group-sm">
                    <button
                      type="button"
                      class="btn btn-info"
                      @click="showDetail(record)"
                    >
                      Ver
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="printClosure(record)"
                    >
                      Imprimir
                    </button>
                    <button
                      type="button"
                      class="btn btn-success"
                      @click="downloadExcel(record._id)"
                    >
                      Excel
                    </button>
                  </div>
                </td>
              </tr>
              </template>
            </tbody>
          </table>
        </div>
        
        <!-- Paginación -->
        <div v-if="totalRecords > 0" class="row mt-3">
          <div class="col-12">
            <div class="pagination-container bg-light border rounded p-3">
              <h6 class="text-muted mb-3">
                <i class="fas fa-list-ol me-2"></i>
                Controles de Paginación
              </h6>
              
              <!-- Información de registros y elementos por página -->
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="d-flex align-items-center">
                  <small class="text-muted me-3">{{ recordsInfo }}</small>
                  <div class="d-flex align-items-center">
                    <label class="form-label small text-muted mb-0 me-2">Mostrar:</label>
                    <select 
                      class="form-select form-select-sm" 
                      style="width: auto;"
                      v-model="localPagination.itemsPerPage" 
                      @change="handleItemsPerPageChange"
                      :disabled="loading"
                    >
                      <option :value="20">20</option>
                      <option :value="50">50</option>
                      <option :value="100">100</option>
                    </select>
                    <small class="text-muted ms-2">por página</small>
                  </div>
                </div>
                
                <!-- Información adicional -->
                <div class="text-end">
                  <small class="text-muted">
                    Página {{ localPagination.currentPage }} de {{ localPagination.totalPages || 1 }}
                  </small>
                </div>
              </div>

              <!-- Spinner de carga -->
              <div v-if="loading" class="d-flex justify-content-center mb-2">
                <div class="spinner-border spinner-border-sm" role="status"></div>
              </div>
              
              <!-- Controles de navegación -->
              <nav aria-label="Paginación de cierres" v-if="localPagination.totalPages > 1">
                <ul class="pagination justify-content-center mb-0">
                  <!-- Primera página -->
                  <li class="page-item" :class="{ disabled: localPagination.currentPage === 1 || loading }">
                    <button 
                      class="page-link" 
                      @click="goToFirstPage"
                      :disabled="localPagination.currentPage === 1 || loading"
                      title="Primera página"
                    >
                      <i class="fas fa-angle-double-left"></i>
                    </button>
                  </li>
                  
                  <!-- Página anterior -->
                  <li class="page-item" :class="{ disabled: localPagination.currentPage === 1 || loading }">
                    <button 
                      class="page-link" 
                      @click="goToPreviousPage"
                      :disabled="localPagination.currentPage === 1 || loading"
                      title="Página anterior"
                    >
                      <i class="fas fa-angle-left"></i>
                    </button>
                  </li>
                  
                  <!-- Páginas numeradas -->
                  <template v-for="page in availablePages">
                    <li 
                      v-if="page === '...'"
                      :key="'ellipsis-' + Math.random()"
                      class="page-item disabled"
                    >
                      <span class="page-link">...</span>
                    </li>
                    <li 
                      v-else
                      :key="page" 
                      class="page-item" 
                      :class="{ active: page === localPagination.currentPage, disabled: loading }"
                    >
                      <button 
                        class="page-link" 
                        @click="changePage(page)"
                        :disabled="loading"
                      >
                        {{ page }}
                      </button>
                    </li>
                  </template>
                  
                  <!-- Página siguiente -->
                  <li class="page-item" :class="{ disabled: localPagination.currentPage === localPagination.totalPages || loading }">
                    <button 
                      class="page-link" 
                      @click="goToNextPage"
                      :disabled="localPagination.currentPage === localPagination.totalPages || loading"
                      title="Página siguiente"
                    >
                      <i class="fas fa-angle-right"></i>
                    </button>
                  </li>
                  
                  <!-- Última página -->
                  <li class="page-item" :class="{ disabled: localPagination.currentPage === localPagination.totalPages || loading }">
                    <button 
                      class="page-link" 
                      @click="goToLastPage"
                      :disabled="localPagination.currentPage === localPagination.totalPages || loading"
                      title="Última página"
                    >
                      <i class="fas fa-angle-double-right"></i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Modal para Guardar/Editar Filtro -->
    <div class="modal fade" 
         id="saveFilterModalCashClosure" 
         tabindex="-1" 
         role="dialog"
         aria-labelledby="saveFilterModalLabel" 
         aria-hidden="true"
         data-bs-backdrop="static"
         :class="{ 'show': showSaveFilterModal }"
         :style="{ display: showSaveFilterModal ? 'block' : 'none', 'z-index': '9045' }">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header text-white" style="background-color: #66C4DE;">
            <h5 class="modal-title" id="saveFilterModalLabel">
              <i :class="isEditingFilter ? 'fas fa-edit me-2' : 'fas fa-save me-2'"></i>
              {{ isEditingFilter ? 'Editar Filtro Guardado' : 'Guardar Configuración de Filtros' }} - Cierres de Caja
            </h5>
            <button type="button" class="btn-close btn-close-white" @click="closeSaveFilterModal"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="saveCurrentFilter">
              <div class="mb-3">
                <label for="filterName" class="form-label">Nombre del Filtro *</label>
                <input 
                  type="text" 
                  class="form-control" 
                  id="filterNameCashClosure"
                  v-model="filterToSave.name"
                  placeholder="Ej: Cierres del mes actual"
                  required
                  maxlength="50"
                >
                <div class="form-text">Máximo 50 caracteres</div>
              </div>
              <div class="mb-3">
                <label for="filterDescription" class="form-label">Descripción</label>
                <textarea 
                  class="form-control" 
                  id="filterDescriptionCashClosure"
                  v-model="filterToSave.description"
                  placeholder="Descripción opcional del filtro..."
                  rows="3"
                  maxlength="200"
                ></textarea>
                <div class="form-text">Máximo 200 caracteres</div>
              </div>
              <div class="alert alert-info">
                <h6 class="alert-heading">
                  <i class="fas fa-info-circle me-2"></i>
                  CONFIGURACIÓN A GUARDAR:
                </h6>
                <ul class="mb-0 small">
                  <li v-if="filters.searchTerm">Búsqueda general: "{{ filters.searchTerm }}"</li>
                  <li v-if="filters.dateFrom">Desde: {{ formatDateForDisplay(filters.dateFrom) }}</li>
                  <li v-if="filters.dateTo">Hasta: {{ formatDateForDisplay(filters.dateTo) }}</li>
                  <li v-if="filters.branch">Sucursal: {{ getBranchName(filters.branch) }}</li>
                  <li v-if="filters.cashier">Caja: {{ filters.cashier }}</li>
                  <li v-else>Búsqueda: Todas las cajas</li>
                  <li>Ordenamiento: {{ getCurrentSortingDescription() }}</li>
                </ul>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeSaveFilterModal">
              CANCELAR
            </button>
            <button type="button" class="btn text-white" @click="saveCurrentFilter" style="background-color: #66C4DE; border-color: #66C4DE;">
              <i :class="isEditingFilter ? 'fas fa-edit me-2' : 'fas fa-save me-2'"></i>
              {{ isEditingFilter ? 'ACTUALIZAR FILTRO' : 'GUARDAR FILTRO' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Modal Backdrop -->
    <div v-if="showSaveFilterModal" 
         class="modal-backdrop fade" 
         :class="{ 'show': showSaveFilterModal }"
         @click="closeSaveFilterModal"></div>
         
    <!-- Modal de Detalle de Cierre -->
    <div class="modal fade" 
         id="cashClosureDetailModal" 
         tabindex="-1" 
         role="dialog"
         aria-labelledby="cashClosureDetailModalLabel" 
         aria-hidden="true"
         aria-modal="true"
         data-bs-backdrop="static"
         :class="{ 'show': showDetailModal }"
         :style="{ display: showDetailModal ? 'block' : 'none', 'z-index': '9050' }"
         @keydown.esc="closeDetailModal">
      <div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title" id="cashClosureDetailModalLabel">
              <i class="fas fa-file-invoice-dollar me-2"></i>
              Detalle del Cierre de Caja
            </h5>
          </div>
          <div class="modal-body" v-if="selectedClosure">
            <!-- Información General -->
            <div class="card mb-4 border-0 shadow-sm">
              <div class="card-header bg-light">
                <h6 class="mb-0 text-primary">
                  <i class="fas fa-info-circle me-2"></i>
                  Información General
                </h6>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <div class="info-item mb-3">
                      <label class="text-muted small d-block mb-1">Responsable</label>
                      <div class="fw-bold">{{ selectedClosure.responsable || 'Sin responsable' }}</div>
                    </div>
                    <div class="info-item mb-3">
                      <label class="text-muted small d-block mb-1">Caja</label>
                      <div class="fw-bold">{{ selectedClosure.caja }}</div>
                    </div>
                    <div class="info-item mb-3">
                      <label class="text-muted small d-block mb-1">Sucursal</label>
                      <div class="fw-bold">{{ selectedClosure.nombreSucursal || 'Sin sucursal' }}</div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="info-item mb-3">
                      <label class="text-muted small d-block mb-1">Fecha de Apertura</label>
                      <div class="fw-bold">
                        {{ formatDate(selectedClosure.fechaApertura) }} 
                        <span class="text-muted">({{ selectedClosure.horaApertura }})</span>
                      </div>
                    </div>
                    <div class="info-item mb-3">
                      <label class="text-muted small d-block mb-1">Fecha de Cierre</label>
                      <div class="fw-bold">
                        {{ formatDate(selectedClosure.fechaCierre) }} 
                        <span class="text-muted">({{ selectedClosure.horaCierre }})</span>
                      </div>
                    </div>
                    <div class="info-item mb-3">
                      <label class="text-muted small d-block mb-1">Estado</label>
                      <div>
                        <span v-if="!selectedClosure.tieneDiferencias" class="badge bg-success">
                          <i class="fas fa-check-circle me-1"></i>
                          Sin Diferencias
                        </span>
                        <span v-else class="badge bg-danger">
                          <i class="fas fa-exclamation-triangle me-1"></i>
                          Con Diferencias ({{ selectedClosure.porcentajeDiferencia }}%)
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Detalle de Ventas por Método de Pago -->
            <div class="card mb-4 border-0 shadow-sm">
              <div class="card-header bg-light">
                <h6 class="mb-0 text-primary">
                  <i class="fas fa-cash-register me-2"></i>
                  Detalle de Ventas por Método de Pago
                </h6>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="payment-method-column">Método de Pago</th>
                        <th class="text-end">Total Sistema</th>
                        <th class="text-end">Total Ratificado</th>
                        <th class="text-end">Diferencia</th>
                        <th class="text-center">Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="payment-method-column">
                          <i class="fas fa-money-bill-wave text-success me-2"></i>
                          Efectivo
                        </td>
                        <td class="text-end">${{ formatMoney(selectedClosure.totalSistema.ventasEfectivo) }}</td>
                        <td class="text-end">${{ formatMoney(selectedClosure.totalRatificado.ventasEfectivo) }}</td>
                        <td class="text-end">
                          <span :class="getPaymentDifferenceClass(selectedClosure.totalSistema.ventasEfectivo, selectedClosure.totalRatificado.ventasEfectivo)">
                            ${{ formatMoney(Math.abs(selectedClosure.totalSistema.ventasEfectivo - selectedClosure.totalRatificado.ventasEfectivo)) }}
                          </span>
                        </td>
                        <td class="text-center">
                          <i :class="getPaymentStatusIcon(selectedClosure.totalSistema.ventasEfectivo, selectedClosure.totalRatificado.ventasEfectivo)"></i>
                        </td>
                      </tr>
                      <tr>
                        <td class="payment-method-column">
                          <i class="fas fa-credit-card text-info me-2"></i>
                          Tarjeta Débito
                        </td>
                        <td class="text-end">${{ formatMoney(selectedClosure.totalSistema.ventasTDebito) }}</td>
                        <td class="text-end">${{ formatMoney(selectedClosure.totalRatificado.ventasTDebito) }}</td>
                        <td class="text-end">
                          <span :class="getPaymentDifferenceClass(selectedClosure.totalSistema.ventasTDebito, selectedClosure.totalRatificado.ventasTDebito)">
                            ${{ formatMoney(Math.abs(selectedClosure.totalSistema.ventasTDebito - selectedClosure.totalRatificado.ventasTDebito)) }}
                          </span>
                        </td>
                        <td class="text-center">
                          <i :class="getPaymentStatusIcon(selectedClosure.totalSistema.ventasTDebito, selectedClosure.totalRatificado.ventasTDebito)"></i>
                        </td>
                      </tr>
                      <tr>
                        <td class="payment-method-column">
                          <i class="fas fa-credit-card text-warning me-2"></i>
                          Tarjeta Crédito
                        </td>
                        <td class="text-end">${{ formatMoney(selectedClosure.totalSistema.ventasTCredito) }}</td>
                        <td class="text-end">${{ formatMoney(selectedClosure.totalRatificado.ventasTCredito) }}</td>
                        <td class="text-end">
                          <span :class="getPaymentDifferenceClass(selectedClosure.totalSistema.ventasTCredito, selectedClosure.totalRatificado.ventasTCredito)">
                            ${{ formatMoney(Math.abs(selectedClosure.totalSistema.ventasTCredito - selectedClosure.totalRatificado.ventasTCredito)) }}
                          </span>
                        </td>
                        <td class="text-center">
                          <i :class="getPaymentStatusIcon(selectedClosure.totalSistema.ventasTCredito, selectedClosure.totalRatificado.ventasTCredito)"></i>
                        </td>
                      </tr>
                      <tr>
                        <td class="payment-method-column">
                          <i class="fas fa-money-check text-secondary me-2"></i>
                          Cheque
                        </td>
                        <td class="text-end">${{ formatMoney(selectedClosure.totalSistema.ventasCheque) }}</td>
                        <td class="text-end">${{ formatMoney(selectedClosure.totalRatificado.ventasCheque) }}</td>
                        <td class="text-end">
                          <span :class="getPaymentDifferenceClass(selectedClosure.totalSistema.ventasCheque, selectedClosure.totalRatificado.ventasCheque)">
                            ${{ formatMoney(Math.abs(selectedClosure.totalSistema.ventasCheque - selectedClosure.totalRatificado.ventasCheque)) }}
                          </span>
                        </td>
                        <td class="text-center">
                          <i :class="getPaymentStatusIcon(selectedClosure.totalSistema.ventasCheque, selectedClosure.totalRatificado.ventasCheque)"></i>
                        </td>
                      </tr>
                      <tr>
                        <td class="payment-method-column">
                          <i class="fas fa-exchange-alt text-primary me-2"></i>
                          Transferencia
                        </td>
                        <td class="text-end">${{ formatMoney(selectedClosure.totalSistema.ventasTransferencia) }}</td>
                        <td class="text-end">${{ formatMoney(selectedClosure.totalRatificado.ventasTransferencia) }}</td>
                        <td class="text-end">
                          <span :class="getPaymentDifferenceClass(selectedClosure.totalSistema.ventasTransferencia, selectedClosure.totalRatificado.ventasTransferencia)">
                            ${{ formatMoney(Math.abs(selectedClosure.totalSistema.ventasTransferencia - selectedClosure.totalRatificado.ventasTransferencia)) }}
                          </span>
                        </td>
                        <td class="text-center">
                          <i :class="getPaymentStatusIcon(selectedClosure.totalSistema.ventasTransferencia, selectedClosure.totalRatificado.ventasTransferencia)"></i>
                        </td>
                      </tr>
                      <tr>
                        <td class="payment-method-column">
                          <i class="fas fa-building text-danger me-2"></i>
                          Crédito Local
                        </td>
                        <td class="text-end">${{ formatMoney(selectedClosure.totalSistema.ventasCreditoLocal) }}</td>
                        <td class="text-end">${{ formatMoney(selectedClosure.totalRatificado.ventasCreditoLocal) }}</td>
                        <td class="text-end">
                          <span :class="getPaymentDifferenceClass(selectedClosure.totalSistema.ventasCreditoLocal, selectedClosure.totalRatificado.ventasCreditoLocal)">
                            ${{ formatMoney(Math.abs(selectedClosure.totalSistema.ventasCreditoLocal - selectedClosure.totalRatificado.ventasCreditoLocal)) }}
                          </span>
                        </td>
                        <td class="text-center">
                          <i :class="getPaymentStatusIcon(selectedClosure.totalSistema.ventasCreditoLocal, selectedClosure.totalRatificado.ventasCreditoLocal)"></i>
                        </td>
                      </tr>
                      <tr class="table-active fw-bold">
                        <td class="payment-method-column">TOTAL VENTAS</td>
                        <td class="text-end">${{ formatMoney(selectedClosure.totalSistema.ventasTotales) }}</td>
                        <td class="text-end">${{ formatMoney(selectedClosure.totalRatificado.ventasTotales) }}</td>
                        <td class="text-end">
                          <span :class="getPaymentDifferenceClass(selectedClosure.totalSistema.ventasTotales, selectedClosure.totalRatificado.ventasTotales)">
                            ${{ formatMoney(Math.abs(selectedClosure.totalRatificado.totalDiferencia || 0)) }}
                          </span>
                        </td>
                        <td class="text-center">
                          <i :class="getPaymentStatusIcon(selectedClosure.totalSistema.ventasTotales, selectedClosure.totalRatificado.ventasTotales)"></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                
                <!-- Resumen de Caja -->
                <div class="row mt-4">
                  <div class="col-md-6">
                    <div class="card bg-light">
                      <div class="card-body">
                        <h6 class="text-muted mb-3">Caja Inicial</h6>
                        <h4 class="text-primary">${{ formatMoney(selectedClosure.totalSistema.cajaInicial) }}</h4>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="card" :class="selectedClosure.tieneDiferencias ? 'bg-danger text-white' : 'bg-success text-white'">
                      <div class="card-body">
                        <h6 class="mb-3">{{ selectedClosure.totalRatificado.indicadorDiferencia || 'DIFERENCIA:' }}</h6>
                        <h4>${{ formatMoney(Math.abs(selectedClosure.totalRatificado.totalDiferencia || 0)) }}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Información Adicional -->
            <div class="card border-0 shadow-sm">
              <div class="card-header bg-light">
                <h6 class="mb-0 text-primary">
                  <i class="fas fa-paperclip me-2"></i>
                  Archivo Adjunto
                </h6>
              </div>
              <div class="card-body">
                <div v-if="selectedClosure.tieneAdjunto" class="d-flex align-items-center mb-3">
                  <div class="me-4">
                    <i class="fas fa-file-excel text-success fa-2x" style="margin-right: 0.75rem;"></i>
                  </div>
                  <div class="flex-grow-1">
                    <div class="fw-bold">{{ selectedClosure.nombreArchivo }}</div>
                    <small class="text-muted">Archivo Excel del cierre de caja</small>
                  </div>
                </div>
                <div v-else class="text-muted mb-3">
                  <i class="fas fa-times-circle me-2"></i>
                  Sin archivo adjunto
                </div>
                
                <!-- Nota informativa -->
                <div class="alert alert-info mb-0 d-flex align-items-start">
                  <i class="fas fa-info-circle mt-1" style="margin-right: 1.5rem;"></i>
                  <div class="flex-grow-1">
                    <strong class="d-block mb-1">Información importante:</strong>
                    <small>
                      El archivo Excel del último cierre de caja del día contiene el consolidado completo de todas las ventas realizadas durante la jornada. 
                      Si descarga este archivo al final del día, obtendrá el detalle total de los registros de ventas en un solo documento.
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer bg-light">
            <div class="container-fluid">
              <div class="row g-2 justify-content-center">
                <div class="col-12 col-sm-6 col-md-3" v-if="selectedClosure && selectedClosure.tieneAdjunto">
                  <button 
                    type="button" 
                    class="btn btn-success w-100 py-2" 
                    @click="downloadExcel(selectedClosure._id)"
                    :disabled="isDownloadingExcel"
                  >
                    <i v-if="isDownloadingExcel" class="fas fa-spinner fa-spin me-2"></i>
                    <i v-else class="fas fa-file-excel me-2"></i>
                    {{ isDownloadingExcel ? 'Descargando...' : 'Descargar Excel' }}
                  </button>
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                  <button 
                    type="button" 
                    class="btn btn-primary w-100 py-2" 
                    @click="printClosure(selectedClosure)" 
                    v-if="selectedClosure"
                    :disabled="isPrintingClosure"
                  >
                    <i v-if="isPrintingClosure" class="fas fa-spinner fa-spin me-2"></i>
                    <i v-else class="fas fa-print me-2"></i>
                    {{ isPrintingClosure ? 'Imprimiendo...' : 'Imprimir' }}
                  </button>
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                  <button 
                    type="button" 
                    class="btn btn-danger w-100 py-2" 
                    @click="exportDetailToPDF" 
                    v-if="selectedClosure"
                    :disabled="isExportingPDF"
                  >
                    <i v-if="isExportingPDF" class="fas fa-spinner fa-spin me-2"></i>
                    <i v-else class="fas fa-file-pdf me-2"></i>
                    {{ isExportingPDF ? 'Exportando...' : 'Exportar PDF' }}
                  </button>
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                  <button 
                    type="button" 
                    class="btn btn-secondary w-100 py-2" 
                    @click="closeDetailModal"
                  >
                    <i class="fas fa-times me-2"></i>
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Modal Backdrop para Detalle -->
    <div v-if="showDetailModal" 
         class="modal-backdrop fade" 
         :class="{ 'show': showDetailModal }"
         @click="closeDetailModal"></div>
         
    <!-- Componente de Impresión Térmica (oculto) -->
    <div v-show="showPrintModal" class="d-none">
      <cash-closure-thermal-print
        ref="thermalPrint"
        :closure-data="closureDataForPrint"
      />
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js';
import XLSXpopulate from 'xlsx-populate';
import { XLSXTemplateDownload, CentralGymOPS_API } from '@/axiosService';
import CashClosureThermalPrint from './CashClosureThermalPrint.vue';

export default {
  name: 'CashClosureTable',
  components: {
    CashClosureThermalPrint
  },
  props: {
    cashiers: Array,
    records: Array,
    loading: Boolean,
    totalRecords: Number,
    allFilteredRecords: Array,
    originalFilteredRecords: Array,
    localPagination: Object,
    metrics: Object
  },
  
  data() {
    return {
      isSearching: false,
      isExporting: false,
      branches: [], // Cargado desde sessionStorage
      filters: {
        searchTerm: '',
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD'),
        branch: '',
        cashier: ''
      },
      // Estados de UI
      showKPIs: true,
      showChartsPanel: false,
      showSavedFilters: false,
      showMobileFilters: false,
      // Filtros guardados
      savedFilters: [],
      filterToSave: {
        name: '',
        description: ''
      },
      isEditingFilter: false,
      filterToEdit: null,
      saveFilterModal: null,
      showSaveFilterModal: false,
      // Ordenamiento
      sorting: {
        field: 'fechaCierre',
        direction: 'desc'
      },
      // Instancias de gráficos
      chartInstances: {
        paymentMethodChart: null,
        branchDifferencesChart: null,
        closureStatusChart: null,
        systemVsVerifiedChart: null,
        differencesAnalysisChart: null,
        branchDetailChart: null
      },
      // Modal de detalle
      showDetailModal: false,
      selectedClosure: null,
      // Flag para exportación PDF
      isExportingPDF: false,
      // Flag para descarga Excel
      isDownloadingExcel: false,
      // Modal de impresión térmica
      showPrintModal: false,
      closureDataForPrint: null,
      isPrintingClosure: false
    };
  },
  
  methods: {
    getTodayDate() {
      return this.$moment().format('YYYY-MM-DD');
    },
    
    formatDate(date) {
      if (!date) return '-';
      return this.$moment(date).format('DD-MM-YYYY');
    },
    
    formatMoney(value) {
      if (!value && value !== 0) return '0';
      return new Intl.NumberFormat('es-CL').format(value);
    },
    
    handleSearch() {
      this.isSearching = true;
      this.$emit('searchUnified', {
        searchText: this.filters.searchTerm,
        dateFrom: this.filters.dateFrom,
        dateTo: this.filters.dateTo,
        branch: this.filters.branch,
        cashier: this.filters.cashier
      });
      setTimeout(() => {
        this.isSearching = false;
      }, 500);
    },
    
    async exportRecords() {
      this.isExporting = true;
      
      this.$swal.fire({
        title: 'Exportando Resumen de Cierres de Caja',
        text: 'Esto puede tardar un poco...',
        icon: 'info',
        iconHtml: '<i class="fa fa-spinner fa-pulse fa-fw"></i><span class="sr-only">Loading...</span>',
        showConfirmButton: false,
        allowOutsideClick: false,
      });
      
      let data;
      let template;
      
      try {
        template = await this.fetchExcelTemplate('ResumenCierresDeCaja');
      } catch (error) {
        console.error(error);
        this.isExporting = false;
        await this.$swal.fire({
          title: 'Error!',
          text: 'Ha ocurrido un error durante la recuperación del template',
          icon: 'error',
          confirmButtonColor: '#6bd098',
        });
        return;
      }
      
      if (!template || template.error) {
        this.isExporting = false;
        await this.$swal.fire({
          title: 'Error!',
          text: template.error || 'Ha ocurrido un error durante la recuperación del template',
          icon: 'error',
          confirmButtonColor: '#6bd098',
        });
        return;
      }
      
      try {
        data = await this.createCashClosingsExportData();
      } catch (error) {
        this.isExporting = false;
        await this.$swal.fire({
          title: 'Error!',
          text: 'Ha ocurrido un error mientras se recuperaba la información: ' + error.message,
          icon: 'error',
          confirmButtonColor: '#6bd098',
        });
        return;
      }
      
      if (!data || data.error) {
        this.isExporting = false;
        await this.$swal.fire({
          title: 'Error!',
          text: data.error || 'Ha ocurrido un error mientras se recuperaba la información',
          icon: 'error',
          confirmButtonColor: '#6bd098',
        });
        return;
      }
      
      try {
        await XLSXpopulate.fromDataAsync(template).then(async (wb) => {
          wb.sheet(0)
            .cell('D3')
            .value(this.$moment().format('DD/MM/YYYY - HH:mm:ss'));
            
          data.forEach((register, i) => {
            // C7 - Número de Registro
            wb.sheet(0).cell(`C${i + 7}`).value(parseInt(i + 1));
            
            // D7 - CAJA
            if (register.caja) {
              wb.sheet(0).cell(`D${i + 7}`).value(register.caja);
            }
            
            // E7 - Responsable
            if (register.responsable) {
              wb.sheet(0).cell(`E${i + 7}`).value(register.responsable);
            }
            
            // F7 - Fecha de Apertura
            if (this.$moment(register.fechaApertura).isValid()) {
              wb.sheet(0).cell(`F${i + 7}`).value(this.$moment(register.fechaApertura).toDate());
            }
            
            // G7 - Hora de Apertura
            if (register.horaApertura) {
              wb.sheet(0).cell(`G${i + 7}`).value(register.horaApertura);
            }
            
            // H7 - Fecha de Cierre
            if (this.$moment(register.fechaCierre).isValid()) {
              wb.sheet(0).cell(`H${i + 7}`).value(this.$moment(register.fechaCierre).toDate());
            }
            
            // I7 - Hora de Cierre
            if (register.horaCierre) {
              wb.sheet(0).cell(`I${i + 7}`).value(register.horaCierre);
            }
            
            // J7 - Sucursal
            if (register.nombreSucursal) {
              wb.sheet(0).cell(`J${i + 7}`).value(register.nombreSucursal);
            }
            
            // K7 - Fecha del Registro
            if (this.$moment(register.fechaRegistro).isValid()) {
              wb.sheet(0).cell(`K${i + 7}`).value(this.$moment(register.fechaRegistro).toDate());
            }
            
            // L7 - Sistema Monto en Efectivo
            wb.sheet(0).cell(`L${i + 7}`).value(register.totalSistema?.ventasEfectivo || 0);
            
            // M7 - Sistema Monto en T. Débito
            wb.sheet(0).cell(`M${i + 7}`).value(register.totalSistema?.ventasTDebito || 0);
            
            // N7 - Sistema Monto en T. Crédito
            wb.sheet(0).cell(`N${i + 7}`).value(register.totalSistema?.ventasTCredito || 0);
            
            // O7 - Sistema Monto en Cheque
            wb.sheet(0).cell(`O${i + 7}`).value(register.totalSistema?.ventasCheque || 0);
            
            // P7 - Sistema Monto en Transferencia
            wb.sheet(0).cell(`P${i + 7}`).value(register.totalSistema?.ventasTransferencia || 0);
            
            // Q7 - Sistema Monto en Crédito Local
            wb.sheet(0).cell(`Q${i + 7}`).value(register.totalSistema?.ventasCreditoLocal || 0);
            
            // R7 - Sistema Monto en Total
            wb.sheet(0).cell(`R${i + 7}`).value(register.totalSistema?.ventasTotales || 0);
            
            // S7 - Sistema Monto en Caja Inicial
            wb.sheet(0).cell(`S${i + 7}`).value(register.totalSistema?.cajaInicial || 0);
            
            // T7 - Sistema Monto en Total en Caja
            wb.sheet(0).cell(`T${i + 7}`).value(register.totalSistema?.totalEnCaja || 0);
            
            // U7 - Monto Ratificado en Efectivo
            wb.sheet(0).cell(`U${i + 7}`).value(register.totalRatificado?.ventasEfectivo || 0);
            
            // V7 - Monto Ratificado en T. Débito
            wb.sheet(0).cell(`V${i + 7}`).value(register.totalRatificado?.ventasTDebito || 0);
            
            // W7 - Monto Ratificado en T. Crédito
            wb.sheet(0).cell(`W${i + 7}`).value(register.totalRatificado?.ventasTCredito || 0);
            
            // X7 - Monto Ratificado en Cheque
            wb.sheet(0).cell(`X${i + 7}`).value(register.totalRatificado?.ventasCheque || 0);
            
            // Y7 - Monto Ratificado en Transferencia
            wb.sheet(0).cell(`Y${i + 7}`).value(register.totalRatificado?.ventasTransferencia || 0);
            
            // Z7 - Monto Ratificado en Crédito Local
            wb.sheet(0).cell(`Z${i + 7}`).value(register.totalRatificado?.ventasCreditoLocal || 0);
            
            // AA7 - Monto Ratificado en Total
            wb.sheet(0).cell(`AA${i + 7}`).value(register.totalRatificado?.ventasTotales || 0);
            
            // AB7 - Monto Ratificado en Caja Inicial
            wb.sheet(0).cell(`AB${i + 7}`).value(register.totalRatificado?.cajaInicial || 0);
            
            // AC7 - Monto Ratificado en Total en Caja
            wb.sheet(0).cell(`AC${i + 7}`).value(register.totalRatificado?.totalEnCaja || 0);
            
            // AD7 - Texto Tipo de Diferencia
            if (register.totalRatificado?.indicadorDiferencia) {
              wb.sheet(0).cell(`AD${i + 7}`).value(register.totalRatificado.indicadorDiferencia);
            }
            
            // AE7 - Diferencia
            wb.sheet(0).cell(`AE${i + 7}`).value(register.totalRatificado?.totalDiferencia || 0);
            
            // AF7 - Tiene Diferencias (Booleano), True = SI, False = NO
            wb.sheet(0).cell(`AF${i + 7}`).value(register.tieneDiferencias ? 'SI' : 'NO');
            
            // AG7 - Porcentaje de Diferencia
            if (register.porcentajeDiferencia) {
              wb.sheet(0).cell(`AG${i + 7}`).value(register.porcentajeDiferencia);
            }
            
            // AH7 - Tiene Archivo Adjunto (Booleano), True = SI, False = NO
            wb.sheet(0).cell(`AH${i + 7}`).value(register.tieneAdjunto ? 'SI' : 'NO');
            
            // AI7 - Nombre Archivo
            if (register.nombreArchivo) {
              wb.sheet(0).cell(`AI${i + 7}`).value(register.nombreArchivo);
            }
          });
          
          // Generar el archivo
          const wbOut = await wb.outputAsync();
          const blob = new Blob([wbOut], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          
          // Descargar el archivo
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Resumen_Cierres_de_Caja_${this.$moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
          
          await this.$swal.fire({
            title: '¡Exportación Exitosa!',
            text: 'El archivo Excel se ha descargado correctamente',
            icon: 'success',
            confirmButtonColor: '#6bd098',
            timer: 3000
          });
        });
      } catch (error) {
        console.error('Error generando Excel:', error);
        await this.$swal.fire({
          title: 'Error!',
          text: 'Ha ocurrido un error al generar el archivo Excel',
          icon: 'error',
          confirmButtonColor: '#6bd098',
        });
      } finally {
        this.isExporting = false;
      }
    },
    
    async fetchExcelTemplate(templateName) {
      try {
        const response = await XLSXTemplateDownload.post(
          '',
          {
            template: templateName,
          },
          {
            headers: {
              'Content-Type': 'application/json',
              token: sessionStorage.getItem('jCxbraoQeD'),
            },
            responseType: 'arraybuffer',
          }
        );
        return response.data;
      } catch (error) {
        console.error('Error al cargar el archivo xlsx:', error);
        return {
          error: error.message || 'Ha ocurrido un error inesperado al recuperar la plantilla excel',
        };
      }
    },
    
    async createCashClosingsExportData() {
      const exportData = [];
      const parameters = {
        fechaInicio: this.filters.dateFrom,
        fechaFin: this.filters.dateTo,
        sucursalId: this.filters.branch || undefined,
        caja: this.filters.cashier ? this.filters.cashier.replace('CAJA ', '') : undefined,
        searchTerm: this.filters.searchTerm || undefined,
        limit: 1000, // Obtener un máximo de 1000 registros
      };
      
      // Limpiar parámetros undefined
      Object.keys(parameters).forEach(key => {
        if (parameters[key] === undefined) {
          delete parameters[key];
        }
      });
      
      const token = sessionStorage.getItem('jCxbraoQeD') || '';
      
      try {
        const response = await CentralGymOPS_API.post('', {
          Header: { Operacion: '/v1/cierres-caja/consultar-paginados' },
          Auth: { Token: token },
          Parameters: parameters,
          Body: {}
        });
        
        const respData = (response.data && (response.data.Response?.Data || response.data.data || response.data.Data)) || {};
        const cierres = respData.cierresCaja || respData.records || [];
        
        // Transformar los datos al formato esperado por el template
        cierres.forEach(cierre => {
          exportData.push({
            caja: cierre.caja,
            responsable: cierre.responsable || 'Sin responsable',
            fechaApertura: cierre.fechaApertura,
            horaApertura: cierre.horaApertura,
            fechaCierre: cierre.fechaCierre,
            horaCierre: cierre.horaCierre,
            nombreSucursal: cierre.nombreSucursal || 'Sin sucursal',
            fechaRegistro: cierre.fechaRegistro || cierre.fechaCierre,
            totalSistema: {
              ventasEfectivo: cierre.totalSistema?.ventasEfectivo || 0,
              ventasTDebito: cierre.totalSistema?.ventasTDebito || 0,
              ventasTCredito: cierre.totalSistema?.ventasTCredito || 0,
              ventasCheque: cierre.totalSistema?.ventasCheque || 0,
              ventasTransferencia: cierre.totalSistema?.ventasTransferencia || 0,
              ventasCreditoLocal: cierre.totalSistema?.ventasCreditoLocal || 0,
              ventasTotales: cierre.totalSistema?.ventasTotales || 0,
              cajaInicial: cierre.totalSistema?.cajaInicial || 0,
              totalEnCaja: cierre.totalSistema?.totalEnCaja || 0
            },
            totalRatificado: {
              ventasEfectivo: cierre.totalRatificado?.ventasEfectivo || 0,
              ventasTDebito: cierre.totalRatificado?.ventasTDebito || 0,
              ventasTCredito: cierre.totalRatificado?.ventasTCredito || 0,
              ventasCheque: cierre.totalRatificado?.ventasCheque || 0,
              ventasTransferencia: cierre.totalRatificado?.ventasTransferencia || 0,
              ventasCreditoLocal: cierre.totalRatificado?.ventasCreditoLocal || 0,
              ventasTotales: cierre.totalRatificado?.ventasTotales || 0,
              cajaInicial: cierre.totalRatificado?.cajaInicial || 0,
              totalEnCaja: cierre.totalRatificado?.totalEnCaja || 0,
              indicadorDiferencia: cierre.totalRatificado?.indicadorDiferencia || '',
              totalDiferencia: cierre.totalRatificado?.totalDiferencia || 0
            },
            tieneDiferencias: cierre.tieneDiferencias || false,
            porcentajeDiferencia: cierre.porcentajeDiferencia || '0.00',
            tieneAdjunto: cierre.tieneAdjunto || false,
            nombreArchivo: cierre.nombreArchivo || ''
          });
        });
        
        return exportData;
      } catch (error) {
        console.error('Error al obtener datos de cierres:', error);
        throw new Error('No se pudieron obtener los datos de cierres de caja');
      }
    },
    
    showDetail(record) {
      this.selectedClosure = record;
      this.showDetailModal = true;
      // Agregar clase al body para prevenir scroll
      document.body.classList.add('modal-open');
      // Agregar listener para tecla Escape
      document.addEventListener('keydown', this.handleEscapeKey);
    },
    
    downloadExcel(recordId) {
      this.isDownloadingExcel = true;
      // Emitir el evento al componente padre
      this.$emit('downloadExcel', recordId);
      // Restaurar el estado después de un tiempo prudencial
      setTimeout(() => {
        this.isDownloadingExcel = false;
      }, 3000);
    },
    
    async printClosure(record) {
      this.isPrintingClosure = true;
      this.$swal.fire({
        title: 'Preparando impresión...',
        text: 'Un momento por favor',
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        }
      });
      
      try {
        // Preparar los datos para impresión
        this.closureDataForPrint = {
          ...record,
          // Asegurar que todos los campos necesarios estén presentes
          totalSistema: record.totalSistema || {
            cajaInicial: 0,
            totalEnCaja: 0,
            ventasCheque: 0,
            ventasCreditoLocal: 0,
            ventasEfectivo: 0,
            ventasTCredito: 0,
            ventasTDebito: 0,
            ventasTotales: 0,
            ventasTransferencia: 0
          },
          totalRatificado: record.totalRatificado || {
            cajaInicial: 0,
            indicadorDiferencia: '',
            totalDiferencia: 0,
            totalEnCaja: 0,
            ventasCheque: 0,
            ventasCreditoLocal: 0,
            ventasEfectivo: 0,
            ventasTCredito: 0,
            ventasTDebito: 0,
            ventasTotales: 0,
            ventasTransferencia: 0
          }
        };
        
        // Cerrar el SweetAlert
        this.$swal.close();
        
        // Mostrar modal de impresión
        this.showPrintModal = true;
        
        // Esperar a que el componente se renderice
        await this.$nextTick();
        await new Promise(resolve => setTimeout(resolve, 100));
        
        // Llamar al método de impresión del componente
        if (this.$refs.thermalPrint) {
          await this.$refs.thermalPrint.print();
        }
        
      } catch (error) {
        console.error('Error al preparar impresión:', error);
        this.$swal.fire({
          icon: 'error',
          title: 'Error al imprimir',
          text: 'No se pudo generar el documento de impresión',
          confirmButtonColor: '#6bd098'
        });
      } finally {
        this.isPrintingClosure = false;
        this.showPrintModal = false;
      }
    },
    
    // Cargar sucursales desde sessionStorage
    loadBranchesFromSession() {
      try {
        const storedBranches = sessionStorage.getItem('xxxwypt5ip');
        if (storedBranches) {
          const parsedBranches = JSON.parse(storedBranches);
          // Verificar si es un array de objetos o strings
          if (Array.isArray(parsedBranches)) {
            this.branches = parsedBranches;
            console.log('✅ Sucursales cargadas desde sessionStorage:', this.branches.length);
          }
        } else {
          console.warn('⚠️ No se encontraron sucursales en sessionStorage');
        }
      } catch (error) {
        console.error('❌ Error al cargar sucursales desde sessionStorage:', error);
      }
    },
    
    // Toggle de paneles
    toggleChartsPanel() {
      this.showChartsPanel = !this.showChartsPanel;
      if (this.showChartsPanel) {
        this.$nextTick(() => {
          this.renderCharts();
        });
      }
    },
    
    toggleSavedFilters() {
      this.showSavedFilters = !this.showSavedFilters;
      if (this.showSavedFilters) {
        this.loadSavedFilters();
      }
    },
    
    // Renderizar gráficos
    renderCharts() {
      if (!this.metrics || !this.showChartsPanel) return;
      
      // Destruir todos los gráficos anteriores
      Object.keys(this.chartInstances).forEach(key => {
        if (this.chartInstances[key]) {
          this.chartInstances[key].destroy();
          this.chartInstances[key] = null;
        }
      });
      
      // Renderizar todos los gráficos
      this.renderPaymentMethodChart();
      this.renderClosureStatusChart();
      this.renderBranchDifferencesChart();
      this.renderSystemVsVerifiedChart();
      this.renderDifferencesAnalysisChart();
      this.renderBranchDetailChart();
    },
    
    renderPaymentMethodChart() {
      const ctx = this.$refs.paymentMethodChart;
      if (!ctx || !this.metrics.distribucionMetodosPago) return;
      
      const data = this.metrics.distribucionMetodosPago;
      const labels = [];
      const values = [];
      const colors = ['#5cb85c', '#5bc0de', '#f0ad4e', '#d9534f', '#6c757d', '#17a2b8'];
      
      Object.entries(data).forEach(([key, value]) => {
        if (value > 0) {
          labels.push(this.getPaymentMethodLabel(key));
          values.push(value);
        }
      });
      
      this.chartInstances.paymentMethodChart = new Chart(ctx, {
        type: 'horizontalBar',
        data: {
          labels: labels,
          datasets: [{
            data: values,
            backgroundColor: colors.slice(0, values.length),
            borderWidth: 2,
            borderColor: '#fff'
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
                callback: function(value) {
                  return '$' + new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(value);
                }
              }
            }]
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                const label = data.labels[tooltipItem.index] || '';
                const value = new Intl.NumberFormat('es-CL', {
                  style: 'currency',
                  currency: 'CLP',
                  minimumFractionDigits: 0
                }).format(tooltipItem.xLabel);
                return label + ': ' + value;
              }
            }
          },
          animation: {
            onComplete: function() {
              const chartInstance = this.chart;
              const ctx = chartInstance.ctx;
              ctx.textBaseline = 'middle';
              ctx.font = 'bold 12px Arial';
              
              this.data.datasets.forEach((dataset, i) => {
                const meta = chartInstance.controller.getDatasetMeta(i);
                meta.data.forEach((bar, index) => {
                  const data = dataset.data[index];
                  const value = '$' + new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(data);
                  
                  // Calcular el ancho de la barra
                  const barWidth = bar._model.x - bar._model.base;
                  
                  // Calcular el ancho del texto
                  const textWidth = ctx.measureText(value).width;
                  
                  // Decidir si mostrar dentro o fuera de la barra
                  if (barWidth > textWidth + 20) {
                    // Mostrar dentro de la barra
                    ctx.textAlign = 'right';
                    ctx.fillStyle = '#fff';
                    const x = bar._model.x - 10;
                    const y = bar._model.y;
                    
                    // Agregar sombra para mejor legibilidad
                    ctx.shadowColor = 'rgba(0, 0, 0, 0.5)';
                    ctx.shadowBlur = 3;
                    ctx.shadowOffsetX = 1;
                    ctx.shadowOffsetY = 1;
                    
                    ctx.fillText(value, x, y);
                    
                    // Resetear sombra
                    ctx.shadowColor = 'transparent';
                    ctx.shadowBlur = 0;
                    ctx.shadowOffsetX = 0;
                    ctx.shadowOffsetY = 0;
                  } else {
                    // Mostrar fuera de la barra
                    ctx.textAlign = 'left';
                    ctx.fillStyle = '#444';
                    const x = bar._model.x + 5;
                    const y = bar._model.y;
                    ctx.fillText(value, x, y);
                  }
                });
              });
            }
          }
        }
      });
    },
    
    renderBranchDifferencesChart() {
      const ctx = this.$refs.branchDifferencesChart;
      if (!ctx || !this.metrics.topSucursales) return;
      
      const topSucursales = this.metrics.topSucursales.slice(0, 5);
      const labels = topSucursales.map(s => {
        const nombre = s.nombreSucursal || 'Sin nombre';
        // Acortar nombres muy largos
        return nombre.length > 30 ? nombre.substring(0, 30) + '...' : nombre;
      });
      const diferencias = topSucursales.map(s => s.totalDiferencias || 0);
      
      this.chartInstances.branchDifferencesChart = new Chart(ctx, {
        type: 'horizontalBar',
        data: {
          labels: labels,
          datasets: [{
            label: 'Total Diferencias',
            data: diferencias,
            backgroundColor: diferencias.map((val, idx) => {
              // Colorear según el porcentaje de cierres con diferencias
              const porcentaje = topSucursales[idx].porcentajeCierresConDiferencias || 0;
              if (porcentaje >= 75) return '#d9534f'; // Rojo para alto porcentaje
              if (porcentaje >= 50) return '#f0ad4e'; // Naranja para medio
              return '#5cb85c'; // Verde para bajo
            }),
            borderColor: diferencias.map((val, idx) => {
              const porcentaje = topSucursales[idx].porcentajeCierresConDiferencias || 0;
              if (porcentaje >= 75) return '#c9302c';
              if (porcentaje >= 50) return '#eea236';
              return '#4cae4c';
            }),
            borderWidth: 2
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
                callback: function(value) {
                  return '$' + new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(value);
                }
              }
            }],
            yAxes: [{
              ticks: {
                callback: function(value) {
                  // Mostrar el porcentaje junto al nombre
                  const index = labels.indexOf(value);
                  if (index !== -1) {
                    const porcentaje = topSucursales[index].porcentajeCierresConDiferencias || 0;
                    return value + ' (' + porcentaje.toFixed(1) + '%)';
                  }
                  return value;
                }
              }
            }]
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                const sucursal = topSucursales[tooltipItem.index];
                const value = new Intl.NumberFormat('es-CL', {
                  style: 'currency',
                  currency: 'CLP',
                  minimumFractionDigits: 0
                }).format(tooltipItem.xLabel);
                return 'Total Diferencias: ' + value;
              },
              afterLabel: function(tooltipItem, data) {
                const sucursal = topSucursales[tooltipItem.index];
                return [
                  `Cierres con diferencias: ${sucursal.cierresConDiferencias} de ${sucursal.totalCierres}`,
                  `Porcentaje: ${(sucursal.porcentajeCierresConDiferencias || 0).toFixed(1)}%`,
                  `Promedio por cierre: $${new Intl.NumberFormat('es-CL').format(sucursal.promedioDiferencia || 0)}`
                ];
              }
            }
          },
          animation: {
            onComplete: function() {
              const chartInstance = this.chart;
              const ctx = chartInstance.ctx;
              ctx.textBaseline = 'middle';
              ctx.font = 'bold 12px Arial';
              
              this.data.datasets.forEach((dataset, i) => {
                const meta = chartInstance.controller.getDatasetMeta(i);
                meta.data.forEach((bar, index) => {
                  const data = dataset.data[index];
                  const value = '$' + new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(data);
                  
                  // Calcular el ancho de la barra
                  const barWidth = bar._model.x - bar._model.base;
                  
                  // Calcular el ancho del texto
                  const textWidth = ctx.measureText(value).width;
                  
                  // Decidir si mostrar dentro o fuera de la barra
                  if (barWidth > textWidth + 20) {
                    // Mostrar dentro de la barra
                    ctx.textAlign = 'right';
                    ctx.fillStyle = '#fff';
                    const x = bar._model.x - 10;
                    const y = bar._model.y;
                    
                    // Agregar sombra para mejor legibilidad
                    ctx.shadowColor = 'rgba(0, 0, 0, 0.5)';
                    ctx.shadowBlur = 3;
                    ctx.shadowOffsetX = 1;
                    ctx.shadowOffsetY = 1;
                    
                    ctx.fillText(value, x, y);
                    
                    // Resetear sombra
                    ctx.shadowColor = 'transparent';
                    ctx.shadowBlur = 0;
                    ctx.shadowOffsetX = 0;
                    ctx.shadowOffsetY = 0;
                  } else {
                    // Mostrar fuera de la barra
                    ctx.textAlign = 'left';
                    ctx.fillStyle = '#444';
                    const x = bar._model.x + 5;
                    const y = bar._model.y;
                    ctx.fillText(value, x, y);
                  }
                });
              });
            }
          }
        }
      });
    },
    
    getPaymentMethodLabel(key) {
      const labels = {
        'efectivo': 'Efectivo',
        'debito': 'T. Débito',
        'credito': 'T. Crédito',
        'cheque': 'Cheque',
        'transferencia': 'Transferencia',
        'creditoLocal': 'Crédito Local'
      };
      return labels[key] || key;
    },
    
    // Nuevo gráfico: Estado de Cierres
    renderClosureStatusChart() {
      const ctx = this.$refs.closureStatusChart;
      if (!ctx || !this.metrics) return;
      
      // Calcular valores monetarios para cada estado
      const totalVentasSistema = this.metrics.totalVentasSistema || 0;
      const totalSobrantes = Math.abs(this.metrics.totalSobrantes || 0);
      const totalFaltantes = Math.abs(this.metrics.totalFaltantes || 0);
      const totalDiferencias = this.metrics.totalDiferencias || 0;
      
      // Calcular el total sin diferencias (ventas sistema - diferencias absolutas)
      const sinDiferencias = totalVentasSistema - (totalSobrantes + totalFaltantes);
      
      const labels = [
        'Sin Diferencias',
        'Total Sobrantes',
        'Total Faltantes'
      ];
      
      const values = [
        Math.max(0, sinDiferencias),
        totalSobrantes,
        totalFaltantes
      ];
      
      this.chartInstances.closureStatusChart = new Chart(ctx, {
        type: 'horizontalBar',
        data: {
          labels: labels,
          datasets: [{
            data: values,
            backgroundColor: ['#5cb85c', '#f0ad4e', '#d9534f'],
            borderWidth: 2,
            borderColor: '#fff'
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
                callback: function(value) {
                  return '$' + new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(value);
                }
              }
            }]
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                const label = data.labels[tooltipItem.index] || '';
                const value = new Intl.NumberFormat('es-CL', {
                  style: 'currency',
                  currency: 'CLP',
                  minimumFractionDigits: 0
                }).format(tooltipItem.xLabel);
                
                // Agregar información adicional según el tipo
                let additionalInfo = '';
                if (tooltipItem.index === 1 && this.metrics.cierresConSobrantes) { // Sobrantes
                  additionalInfo = ` (${this.metrics.cierresConSobrantes} cierres)`;
                } else if (tooltipItem.index === 2 && this.metrics.cierresConFaltantes) { // Faltantes
                  additionalInfo = ` (${this.metrics.cierresConFaltantes} cierres)`;
                }
                
                return label + ': ' + value + additionalInfo;
              }
            }
          },
          animation: {
            onComplete: function() {
              const chartInstance = this.chart;
              const ctx = chartInstance.ctx;
              ctx.textBaseline = 'middle';
              ctx.font = 'bold 12px Arial';
              
              this.data.datasets.forEach((dataset, i) => {
                const meta = chartInstance.controller.getDatasetMeta(i);
                meta.data.forEach((bar, index) => {
                  const data = dataset.data[index];
                  const value = '$' + new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(data);
                  
                  // Calcular el ancho de la barra
                  const barWidth = bar._model.x - bar._model.base;
                  
                  // Calcular el ancho del texto
                  const textWidth = ctx.measureText(value).width;
                  
                  // Decidir si mostrar dentro o fuera de la barra
                  if (barWidth > textWidth + 20) {
                    // Mostrar dentro de la barra
                    ctx.textAlign = 'right';
                    ctx.fillStyle = '#fff';
                    const x = bar._model.x - 10;
                    const y = bar._model.y;
                    
                    // Agregar sombra para mejor legibilidad
                    ctx.shadowColor = 'rgba(0, 0, 0, 0.5)';
                    ctx.shadowBlur = 3;
                    ctx.shadowOffsetX = 1;
                    ctx.shadowOffsetY = 1;
                    
                    ctx.fillText(value, x, y);
                    
                    // Resetear sombra
                    ctx.shadowColor = 'transparent';
                    ctx.shadowBlur = 0;
                    ctx.shadowOffsetX = 0;
                    ctx.shadowOffsetY = 0;
                  } else {
                    // Mostrar fuera de la barra
                    ctx.textAlign = 'left';
                    ctx.fillStyle = '#444';
                    const x = bar._model.x + 5;
                    const y = bar._model.y;
                    ctx.fillText(value, x, y);
                  }
                });
              });
            }
          }
        }
      });
    },
    
    // Nuevo gráfico: Sistema vs Ratificado
    renderSystemVsVerifiedChart() {
      const ctx = this.$refs.systemVsVerifiedChart;
      if (!ctx || !this.metrics) return;
      
      const sistema = this.metrics.totalVentasSistema || 0;
      const ratificado = this.metrics.totalVentasRatificadas || 0;
      const diferencia = sistema - ratificado;
      
      this.chartInstances.systemVsVerifiedChart = new Chart(ctx, {
        type: 'horizontalBar',
        data: {
          labels: ['Total Sistema', 'Total Ratificado', 'Diferencia'],
          datasets: [{
            label: 'Montos',
            data: [sistema, ratificado, Math.abs(diferencia)],
            backgroundColor: ['#5bc0de', '#5cb85c', diferencia >= 0 ? '#f0ad4e' : '#d9534f'],
            borderColor: ['#46b8da', '#4cae4c', diferencia >= 0 ? '#eea236' : '#c9302c'],
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
                callback: function(value) {
                  return '$' + new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(value);
                }
              }
            }]
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                const dataset = data.datasets[tooltipItem.datasetIndex];
                const value = new Intl.NumberFormat('es-CL', {
                  style: 'currency',
                  currency: 'CLP',
                  minimumFractionDigits: 0
                }).format(tooltipItem.xLabel);
                return dataset.label + ': ' + value;
              }
            }
          },
          animation: {
            onComplete: function() {
              const chartInstance = this.chart;
              const ctx = chartInstance.ctx;
              ctx.textAlign = 'right';
              ctx.textBaseline = 'middle';
              ctx.fillStyle = '#fff';
              ctx.font = 'bold 12px Arial';
              
              this.data.datasets.forEach((dataset, i) => {
                const meta = chartInstance.controller.getDatasetMeta(i);
                meta.data.forEach((bar, index) => {
                  const data = dataset.data[index];
                  const value = '$' + new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(data);
                  
                  // Calcular el ancho de la barra
                  const barWidth = bar._model.x - bar._model.base;
                  
                  // Calcular el ancho del texto
                  const textWidth = ctx.measureText(value).width;
                  
                  // Solo mostrar el texto si hay suficiente espacio en la barra
                  if (barWidth > textWidth + 20) {
                    const x = bar._model.x - 10; // Posición dentro de la barra, cerca del borde derecho
                    const y = bar._model.y;
                    
                    // Agregar sombra para mejor legibilidad
                    ctx.shadowColor = 'rgba(0, 0, 0, 0.5)';
                    ctx.shadowBlur = 3;
                    ctx.shadowOffsetX = 1;
                    ctx.shadowOffsetY = 1;
                    
                    ctx.fillText(value, x, y);
                    
                    // Resetear sombra
                    ctx.shadowColor = 'transparent';
                    ctx.shadowBlur = 0;
                    ctx.shadowOffsetX = 0;
                    ctx.shadowOffsetY = 0;
                  }
                });
              });
            }
          }
        }
      });
    },
    
    // Nuevo gráfico: Análisis de Diferencias
    renderDifferencesAnalysisChart() {
      const ctx = this.$refs.differencesAnalysisChart;
      if (!ctx || !this.metrics) return;
      
      // Preparar datos con etiquetas más descriptivas
      const dataItems = [
        {
          label: 'Mayor Diferencia',
          value: this.metrics.mayorDiferencia || 0,
          color: '#d9534f',
          borderColor: '#c9302c',
          description: 'La diferencia más alta registrada'
        },
        {
          label: 'Total Sobrantes',
          value: this.metrics.totalSobrantes || 0,
          color: '#f0ad4e',
          borderColor: '#eea236',
          description: 'Suma de todos los sobrantes'
        },
        {
          label: 'Total Faltantes',
          value: Math.abs(this.metrics.totalFaltantes || 0),
          color: '#5cb85c',
          borderColor: '#4cae4c',
          description: 'Suma de todos los faltantes'
        },
        {
          label: 'Promedio por Cierre',
          value: this.metrics.promedioDiferencia || 0,
          color: '#5bc0de',
          borderColor: '#46b8da',
          description: 'Diferencia promedio por cierre'
        }
      ];
      
      // Ordenar de mayor a menor
      dataItems.sort((a, b) => b.value - a.value);
      
      this.chartInstances.differencesAnalysisChart = new Chart(ctx, {
        type: 'horizontalBar',
        data: {
          labels: dataItems.map(item => item.label),
          datasets: [{
            data: dataItems.map(item => item.value),
            backgroundColor: dataItems.map(item => item.color),
            borderColor: dataItems.map(item => item.borderColor),
            borderWidth: 2
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
                callback: function(value) {
                  return '$' + new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(value);
                }
              }
            }],
            yAxes: [{
              ticks: {
                callback: function(value) {
                  // Agregar indicador visual para valores cero
                  const index = dataItems.findIndex(item => item.label === value);
                  if (index !== -1 && dataItems[index].value === 0) {
                    return value + ' (Sin registros)';
                  }
                  return value;
                }
              }
            }]
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                const item = dataItems[tooltipItem.index];
                const value = new Intl.NumberFormat('es-CL', {
                  style: 'currency',
                  currency: 'CLP',
                  minimumFractionDigits: 0
                }).format(tooltipItem.xLabel);
                return value;
              },
              afterLabel: function(tooltipItem, data) {
                const item = dataItems[tooltipItem.index];
                return item.description;
              }
            }
          },
          animation: {
            onComplete: function() {
              const chartInstance = this.chart;
              const ctx = chartInstance.ctx;
              ctx.textBaseline = 'middle';
              ctx.font = 'bold 12px Arial';
              
              this.data.datasets.forEach((dataset, i) => {
                const meta = chartInstance.controller.getDatasetMeta(i);
                meta.data.forEach((bar, index) => {
                  const data = dataset.data[index];
                  const value = '$' + new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(data);
                  
                  // Para valores cero, mostrar el texto fuera de la barra
                  if (data === 0) {
                    ctx.textAlign = 'left';
                    ctx.fillStyle = '#444';
                    const x = bar._model.base + 5;
                    const y = bar._model.y;
                    ctx.fillText('$0', x, y);
                  } else {
                    // Calcular el ancho de la barra
                    const barWidth = bar._model.x - bar._model.base;
                    
                    // Calcular el ancho del texto
                    const textWidth = ctx.measureText(value).width;
                    
                    // Decidir si mostrar dentro o fuera de la barra
                    if (barWidth > textWidth + 20) {
                      // Mostrar dentro de la barra
                      ctx.textAlign = 'right';
                      ctx.fillStyle = '#fff';
                      const x = bar._model.x - 10;
                      const y = bar._model.y;
                      
                      // Agregar sombra para mejor legibilidad
                      ctx.shadowColor = 'rgba(0, 0, 0, 0.5)';
                      ctx.shadowBlur = 3;
                      ctx.shadowOffsetX = 1;
                      ctx.shadowOffsetY = 1;
                      
                      ctx.fillText(value, x, y);
                      
                      // Resetear sombra
                      ctx.shadowColor = 'transparent';
                      ctx.shadowBlur = 0;
                      ctx.shadowOffsetX = 0;
                      ctx.shadowOffsetY = 0;
                    } else {
                      // Mostrar fuera de la barra
                      ctx.textAlign = 'left';
                      ctx.fillStyle = '#444';
                      const x = bar._model.x + 5;
                      const y = bar._model.y;
                      ctx.fillText(value, x, y);
                    }
                  }
                });
              });
            }
          }
        }
      });
    },
    
    // Nuevo gráfico: Detalle por Sucursal
    renderBranchDetailChart() {
      const ctx = this.$refs.branchDetailChart;
      if (!ctx || !this.metrics.topSucursales) return;
      
      const topSucursales = this.metrics.topSucursales.slice(0, 5);
      const labels = topSucursales.map(s => {
        const nombre = s.nombreSucursal || 'Sin nombre';
        return nombre.length > 20 ? nombre.substring(0, 20) + '...' : nombre;
      });
      
      this.chartInstances.branchDetailChart = new Chart(ctx, {
        type: 'horizontalBar',
        data: {
          labels: labels,
          datasets: [
            {
              label: 'Total Ventas',
              data: topSucursales.map(s => s.totalVentas || 0),
              backgroundColor: '#5bc0de',
              borderColor: '#46b8da',
              borderWidth: 1
            },
            {
              label: 'Promedio Ventas Diarias',
              data: topSucursales.map(s => s.promedioVentasDiarias || 0),
              backgroundColor: '#5cb85c',
              borderColor: '#4cae4c',
              borderWidth: 1
            },
            {
              label: 'Mayor Venta Día',
              data: topSucursales.map(s => s.mayorVentaDia || 0),
              backgroundColor: '#f0ad4e',
              borderColor: '#eea236',
              borderWidth: 1
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
                callback: function(value) {
                  return '$' + new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(value);
                }
              }
            }]
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                const dataset = data.datasets[tooltipItem.datasetIndex];
                const value = tooltipItem.xLabel || tooltipItem.value;
                const formattedValue = new Intl.NumberFormat('es-CL', {
                  style: 'currency',
                  currency: 'CLP',
                  minimumFractionDigits: 0
                }).format(value);
                return dataset.label + ': ' + formattedValue;
              },
              afterLabel: function(tooltipItem, data) {
                const sucursal = topSucursales[tooltipItem.index];
                return [
                  `Total Cierres: ${sucursal.totalCierres}`,
                  `Cierres con Diferencias: ${sucursal.cierresConDiferencias}`,
                  `% con Diferencias: ${(sucursal.porcentajeCierresConDiferencias || 0).toFixed(1)}%`
                ];
              }
            }
          },
          animation: {
            onComplete: function() {
              const chartInstance = this.chart;
              const ctx = chartInstance.ctx;
              ctx.textBaseline = 'middle';
              ctx.font = 'bold 11px Arial'; // Fuente más pequeña para múltiples datasets
              
              this.data.datasets.forEach((dataset, i) => {
                const meta = chartInstance.controller.getDatasetMeta(i);
                meta.data.forEach((bar, index) => {
                  const data = dataset.data[index];
                  const value = '$' + new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(data);
                  
                  // Calcular el ancho de la barra
                  const barWidth = bar._model.x - bar._model.base;
                  
                  // Calcular el ancho del texto
                  const textWidth = ctx.measureText(value).width;
                  
                  // Decidir si mostrar dentro o fuera de la barra
                  if (barWidth > textWidth + 15) { // Margen reducido para datasets múltiples
                    // Mostrar dentro de la barra
                    ctx.textAlign = 'right';
                    ctx.fillStyle = '#fff';
                    const x = bar._model.x - 8;
                    const y = bar._model.y;
                    
                    // Agregar sombra para mejor legibilidad
                    ctx.shadowColor = 'rgba(0, 0, 0, 0.5)';
                    ctx.shadowBlur = 3;
                    ctx.shadowOffsetX = 1;
                    ctx.shadowOffsetY = 1;
                    
                    ctx.fillText(value, x, y);
                    
                    // Resetear sombra
                    ctx.shadowColor = 'transparent';
                    ctx.shadowBlur = 0;
                    ctx.shadowOffsetX = 0;
                    ctx.shadowOffsetY = 0;
                  } else {
                    // Mostrar fuera de la barra
                    ctx.textAlign = 'left';
                    ctx.fillStyle = '#444';
                    const x = bar._model.x + 5;
                    const y = bar._model.y;
                    ctx.fillText(value, x, y);
                  }
                });
              });
            }
          }
        }
      });
    },
    
    // Métodos de filtros guardados
    loadSavedFilters() {
      const saved = localStorage.getItem('cashClosureFilters');
      if (saved) {
        try {
          this.savedFilters = JSON.parse(saved);
        } catch (error) {
          console.error('Error al cargar filtros guardados:', error);
          this.savedFilters = [];
        }
      }
    },
    
    saveSavedFilters() {
      localStorage.setItem('cashClosureFilters', JSON.stringify(this.savedFilters));
    },
    
    openSaveFilterModal() {
      // Solo limpiar si no estamos editando
      if (!this.isEditingFilter) {
        this.filterToSave.name = '';
        this.filterToSave.description = '';
      }
      
      // Mostrar modal usando Vue
      this.showSaveFilterModal = true;
      
      // Agregar clase al body para prevenir scroll
      document.body.classList.add('modal-open');
    },
    
    closeSaveFilterModal() {
      this.showSaveFilterModal = false;
      
      // Remover clase del body
      document.body.classList.remove('modal-open');
      
      // Limpiar estado de edición al cerrar
      this.isEditingFilter = false;
      this.filterToEdit = null;
    },
    
    saveCurrentFilter() {
      if (!this.filterToSave.name.trim()) {
        this.$swal.fire({
          icon: 'warning',
          title: 'Nombre requerido',
          text: 'Por favor, ingresa un nombre para el filtro',
          confirmButtonColor: '#6bd098'
        });
        return;
      }

      if (this.isEditingFilter && this.filterToEdit) {
        // MODO EDICIÓN: Actualizar filtro existente
        const filterIndex = this.savedFilters.findIndex(f => f.id === this.filterToEdit.id);
        if (filterIndex !== -1) {
          // Mantener ID original y fecha de creación, actualizar el resto
          this.savedFilters[filterIndex] = {
            ...this.savedFilters[filterIndex],
            name: this.filterToSave.name.trim(),
            description: this.filterToSave.description.trim(),
            filters: { ...this.filters },
            sorting: { ...this.sorting },
            updatedAt: new Date().toISOString() // Agregar fecha de actualización
          };
          
          this.saveSavedFilters();
          this.closeSaveFilterModal();
          
          this.$swal.fire({
            icon: 'success',
            title: '¡Filtro actualizado!',
            text: `El filtro "${this.filterToSave.name.trim()}" se ha actualizado correctamente`,
            confirmButtonColor: '#6bd098'
          });
        }
      } else {
        // MODO CREACIÓN: Crear nuevo filtro
        const filterConfig = {
          id: Date.now(),
          name: this.filterToSave.name.trim(),
          description: this.filterToSave.description.trim(),
          filters: { ...this.filters },
          sorting: { ...this.sorting },
          createdAt: new Date().toISOString()
        };

        this.savedFilters.push(filterConfig);
        this.saveSavedFilters();
        this.closeSaveFilterModal();

        this.$swal.fire({
          icon: 'success',
          title: '¡Filtro guardado!',
          text: `El filtro "${filterConfig.name}" se ha guardado correctamente`,
          confirmButtonColor: '#6bd098'
        });
      }
    },
    
    applySavedFilter(filter) {
      // Aplicar configuración de filtros guardados
      this.filters = { ...filter.filters };
      this.sorting = { ...filter.sorting };
      
      // Ejecutar búsqueda
      this.handleSearch();
      
      // Mostrar notificación breve no bloqueante
      this.$swal.fire({
        position: 'top-end',
        icon: 'info',
        title: `Filtro "${filter.name}" aplicado`,
        showConfirmButton: false,
        timer: 2000,
        toast: true
      });
    },
    
    editSavedFilter(filter) {
      // Marcar que estamos editando
      this.isEditingFilter = true;
      this.filterToEdit = filter;
      
      // Pre-cargar datos en el modal
      this.filterToSave.name = filter.name;
      this.filterToSave.description = filter.description || '';
      
      // Pre-cargar filtros actuales en el formulario
      this.filters = { ...filter.filters };
      this.sorting = { ...filter.sorting };
      
      // Abrir modal
      this.openSaveFilterModal();
    },
    
    duplicateSavedFilter(filter) {
      const duplicatedFilter = {
        id: Date.now(), // Nuevo ID único
        name: `${filter.name} (Copia)`,
        description: `Copia de: ${filter.description || filter.name}`,
        filters: { ...filter.filters },
        sorting: { ...filter.sorting },
        createdAt: new Date().toISOString()
      };

      this.savedFilters.push(duplicatedFilter);
      this.saveSavedFilters();
      
      this.$swal.fire({
        icon: 'success',
        title: '¡Filtro duplicado!',
        text: `Se ha creado una copia del filtro "${filter.name}"`,
        timer: 2000,
        showConfirmButton: false
      });
    },
    
    deleteSavedFilter(filter) {
      this.$swal.fire({
        title: '¿Eliminar filtro?',
        text: `¿Estás seguro de eliminar el filtro "${filter.name}"?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.savedFilters = this.savedFilters.filter(f => f.id !== filter.id);
          this.saveSavedFilters();
          
          this.$swal.fire({
            icon: 'success',
            title: '¡Filtro eliminado!',
            text: `El filtro "${filter.name}" ha sido eliminado correctamente`,
            timer: 2000,
            showConfirmButton: false
          });
        }
      });
    },
    
    // Métodos auxiliares para filtros guardados
    formatDateForDisplay(date) {
      if (!date) return '';
      return this.$moment(date).format('DD-MM-YYYY');
    },
    
    getBranchName(branchId) {
      if (!branchId) return 'Todas las sucursales';
      const branch = this.branches.find(b => 
        (b._id === branchId) || 
        (b.id === branchId) || 
        (b === branchId)
      );
      return branch?.nombreSucursal || branch?.nombre || branchId;
    },
    
    getCurrentSortingDescription() {
      const fieldNames = {
        fechaCierre: 'Fecha de Cierre',
        caja: 'Caja',
        responsable: 'Responsable',
        nombreSucursal: 'Sucursal',
        totalSistema: 'Total Sistema',
        totalRatificado: 'Total Ratificado',
        diferencia: 'Diferencia'
      };
      
      const fieldName = fieldNames[this.sorting.field] || this.sorting.field;
      const direction = this.sorting.direction === 'asc' ? 'Ascendente' : 'Descendente';
      
      return `${fieldName} (${direction})`;
    },
    
    getRelativeTime(date) {
      if (!date) return '';
      const moment = this.$moment(date);
      const now = this.$moment();
      const diffInDays = now.diff(moment, 'days');
      
      if (diffInDays === 0) {
        return 'hoy';
      } else if (diffInDays === 1) {
        return 'ayer';
      } else if (diffInDays < 7) {
        return `hace ${diffInDays} días`;
      } else if (diffInDays < 30) {
        const weeks = Math.floor(diffInDays / 7);
        return `hace ${weeks} semana${weeks > 1 ? 's' : ''}`;
      } else if (diffInDays < 365) {
        const months = Math.floor(diffInDays / 30);
        return `hace ${months} mes${months > 1 ? 'es' : ''}`;
      } else {
        const years = Math.floor(diffInDays / 365);
        return `hace ${years} año${years > 1 ? 's' : ''}`;
      }
    },
    
    // Métodos de paginación
    handleItemsPerPageChange() {
      // Emitir el cambio de items por página junto con el nuevo valor
      this.$emit('changeItemsPerPage', this.localPagination.itemsPerPage);
    },
    
    changePage(page) {
      if (page !== this.localPagination.currentPage && !this.loading) {
        this.$emit('fetchNewPage', page);
      }
    },
    
    goToFirstPage() {
      if (this.localPagination.currentPage !== 1) {
        this.changePage(1);
      }
    },
    
    goToPreviousPage() {
      if (this.localPagination.currentPage > 1) {
        this.changePage(this.localPagination.currentPage - 1);
      }
    },
    
    goToNextPage() {
      if (this.localPagination.currentPage < this.localPagination.totalPages) {
        this.changePage(this.localPagination.currentPage + 1);
      }
    },
    
    goToLastPage() {
      if (this.localPagination.currentPage !== this.localPagination.totalPages) {
        this.changePage(this.localPagination.totalPages);
      }
    },
    
    // Métodos del modal de detalle
    closeDetailModal() {
      this.showDetailModal = false;
      this.selectedClosure = null;
      // Remover clase del body
      document.body.classList.remove('modal-open');
      // Remover listener de tecla Escape
      document.removeEventListener('keydown', this.handleEscapeKey);
    },
    
    // Manejar tecla Escape
    handleEscapeKey(event) {
      if (event.key === 'Escape' && this.showDetailModal) {
        this.closeDetailModal();
      }
    },
    
    getPaymentDifferenceClass(sistema, ratificado) {
      const diff = sistema - ratificado;
      if (diff === 0) return 'text-success';
      if (diff > 0) return 'text-danger';  // Más en sistema que ratificado (faltante)
      return 'text-warning';  // Menos en sistema que ratificado (sobrante)
    },
    
    getPaymentStatusIcon(sistema, ratificado) {
      const diff = sistema - ratificado;
      if (diff === 0) return 'fas fa-check-circle text-success';
      if (Math.abs(diff) < 1000) return 'fas fa-exclamation-circle text-warning';
      return 'fas fa-times-circle text-danger';
    },
    
    async exportDetailToPDF() {
      if (!this.selectedClosure) return;
      
      this.isExportingPDF = true;
      
      try {

        // Importar dinámicamente las librerías necesarias
        const [{ default: html2canvas }, { jsPDF }] = await Promise.all([
          import('html2canvas'),
          import('jspdf')
        ]);

        // Asegurar que el modal esté completamente renderizado
        await this.$nextTick();
        await new Promise(resolve => setTimeout(resolve, 100));

        // Crear nueva instancia de PDF
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const margin = 15;
        const contentWidth = pageWidth - (margin * 2);
        let yPosition = margin;

        // 1. HEADER DEL PDF
        pdf.setFontSize(16);
        pdf.setFont('helvetica', 'bold');
        pdf.text('DETALLE DE CIERRE DE CAJA', pageWidth / 2, yPosition, { align: 'center' });
        yPosition += 10;

        pdf.setFontSize(10);
        pdf.setFont('helvetica', 'normal');
        const fechaGeneracion = new Date().toLocaleDateString('es-CL', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
        pdf.text(`Generado: ${fechaGeneracion}`, pageWidth / 2, yPosition, { align: 'center' });
        yPosition += 20;

        // 2. CAPTURAR EL CONTENIDO DEL MODAL
        // Encontrar el contenedor del modal body
        const modalBody = document.querySelector('#cashClosureDetailModal .modal-body');
        
        if (modalBody) {
          // Ocultar temporalmente los scrollbars del modal
          const originalOverflow = modalBody.style.overflow;
          modalBody.style.overflow = 'visible';
          
          try {
            // Capturar el contenido del modal con html2canvas
            const canvas = await html2canvas(modalBody, {
              allowTaint: true,
              useCORS: true,
              scale: 2, // Mayor calidad
              backgroundColor: '#ffffff',
              logging: false,
              windowWidth: modalBody.scrollWidth,
              windowHeight: modalBody.scrollHeight
            });

            // Calcular las dimensiones para mantener la proporción
            const imgWidth = contentWidth;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            
            // Dividir la imagen en páginas si es necesario
            const imgData = canvas.toDataURL('image/png');
            let heightLeft = imgHeight;
            let position = yPosition;

            // Agregar la primera parte de la imagen
            const firstPageHeight = pageHeight - margin - position - 20; // 20 para el footer
            if (imgHeight <= firstPageHeight) {
              // La imagen cabe en una sola página
              pdf.addImage(imgData, 'PNG', margin, position, imgWidth, imgHeight);
            } else {
              // La imagen necesita múltiples páginas
              pdf.addImage(imgData, 'PNG', margin, position, imgWidth, firstPageHeight, undefined, undefined, 0, 0, canvas.width, (firstPageHeight * canvas.width) / imgWidth);
              heightLeft -= firstPageHeight;
              
              // Agregar páginas adicionales según sea necesario
              while (heightLeft > 0) {
                pdf.addPage();
                position = margin;
                const pageContentHeight = pageHeight - (margin * 2) - 20; // 20 para el footer
                const remainingHeight = Math.min(pageContentHeight, heightLeft);
                
                pdf.addImage(
                  imgData, 
                  'PNG', 
                  margin, 
                  position, 
                  imgWidth, 
                  remainingHeight,
                  undefined,
                  undefined,
                  0,
                  ((imgHeight - heightLeft) * canvas.width) / imgWidth,
                  canvas.width,
                  (remainingHeight * canvas.width) / imgWidth
                );
                
                heightLeft -= remainingHeight;
              }
            }
            
            // Restaurar el overflow original
            modalBody.style.overflow = originalOverflow;
            
          } catch (canvasError) {
            console.error('Error al capturar el contenido del modal:', canvasError);
            // Restaurar el overflow en caso de error
            modalBody.style.overflow = originalOverflow;
            throw new Error('No se pudo capturar el diseño del modal');
          }
        } else {
          throw new Error('No se encontró el contenido del modal para capturar');
        }

        // 3. FOOTER (en todas las páginas)
        const totalPages = pdf.internal.getNumberOfPages();
        
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(8);
          pdf.setFont('helvetica', 'normal');
          
          // Línea separadora del footer
          pdf.setDrawColor(200, 200, 200);
          pdf.line(margin, pageHeight - 10, pageWidth - margin, pageHeight - 10);
          
          // Información izquierda: Cierre de caja
          pdf.text(`Cierre: ${this.selectedClosure.caja} - ${this.formatDate(this.selectedClosure.fechaCierre)}`, margin, pageHeight - 5);
          
          // Información centro: Texto de CentralGym
          pdf.text('Informe generado desde CentralGym App - https://centralgym.cl', pageWidth / 2, pageHeight - 5, { align: 'center' });
          
          // Información derecha: Numeración de páginas
          pdf.text(`Página ${i} de ${totalPages}`, pageWidth - margin, pageHeight - 5, { align: 'right' });
        }

        // 4. Generar nombre de archivo
        const fechaArchivo = this.formatDate(this.selectedClosure.fechaCierre).replace(/\//g, '-');
        const nombreArchivo = `Detalle Cierre Caja ${this.selectedClosure.caja} - ${fechaArchivo}.pdf`;

        // 5. Descargar PDF
        pdf.save(nombreArchivo);

        // 6. Esperar un momento para asegurar que el PDF se guardó
        await new Promise(resolve => setTimeout(resolve, 500));

        console.log('✅ PDF generado exitosamente con el diseño visual del modal');

      } catch (error) {
        console.error('Error al exportar PDF:', error);
      } finally {
        this.isExportingPDF = false;
      }
    },
    
    // Método para exportar gráficos a PDF
    async exportChartsToPDF() {
      console.log('🎯 Iniciando proceso de exportación PDF de gráficos...');
      this.isExportingPDF = true;
      
      // Validar que hay datos para exportar
      if (!this.metrics || Object.keys(this.metrics).length === 0) {
        console.warn('⚠️ No hay métricas disponibles para exportar');
        this.$swal.fire({
          icon: 'warning',
          title: 'Sin datos para exportar',
          text: 'No hay información de cierres de caja disponible para generar el reporte.',
          confirmButtonColor: '#6bd098'
        });
        this.isExportingPDF = false;
        return;
      }
      
      try {
        // Importar dinámicamente las librerías necesarias
        let html2canvas, jsPDF;
        try {
          console.log('📚 Importando librerías para PDF...');
          const html2canvasModule = await import('html2canvas');
          html2canvas = html2canvasModule.default || html2canvasModule;
          
          const jsPDFModule = await import('jspdf');
          // jsPDF v3 exporta diferente, intentar ambas formas
          jsPDF = jsPDFModule.jsPDF || jsPDFModule.default || jsPDFModule;
          
          console.log('✅ Librerías importadas:', { 
            html2canvas: typeof html2canvas, 
            jsPDF: typeof jsPDF 
          });
        } catch (importError) {
          console.error('❌ Error al importar librerías PDF:', importError);
          throw new Error('No se pudieron cargar las librerías necesarias para generar el PDF');
        }
        
        // Asegurar que todo esté renderizado
        await this.$nextTick();
        await new Promise(resolve => setTimeout(resolve, 500));
        
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const margin = 15;
        const contentWidth = pageWidth - (margin * 2);
        let yPosition = margin;
        
        // 1. Agregar título principal
        pdf.setFontSize(16);
        pdf.setFont('helvetica', 'bold');
        pdf.text('ANÁLISIS VISUAL - CIERRES DE CAJA', pageWidth / 2, yPosition, { align: 'center' });
        yPosition += 10;
        
        // 2. Agregar información del período consultado
        pdf.setFontSize(12);
        pdf.setFont('helvetica', 'normal');
        const rangoFechas = this.getRangoFechasConsultado();
        pdf.text(rangoFechas, pageWidth / 2, yPosition, { align: 'center' });
        yPosition += 8;
        
        // 3. Agregar fecha de generación
        pdf.setFontSize(10);
        const fechaGeneracion = new Date().toLocaleDateString('es-CL', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
        pdf.text(`Generado: ${fechaGeneracion}`, pageWidth / 2, yPosition, { align: 'center' });
        yPosition += 15;
        
        // 4. Capturar y agregar panel de KPIs (si está visible)
        if (this.showKPIs && this.$refs.kpisSection) {
          try {
            console.log('📸 Capturando sección de KPIs...');
            
            const kpisCanvas = await html2canvas(this.$refs.kpisSection, {
              allowTaint: true,
              useCORS: true,
              scale: 3,
              backgroundColor: '#ffffff',
              logging: false
            });
            
            const kpisImgData = kpisCanvas.toDataURL('image/png');
            const kpisHeight = (kpisCanvas.height * contentWidth) / kpisCanvas.width;
            
            // Verificar si cabe en la página actual
            if (yPosition + kpisHeight > pageHeight - margin) {
              pdf.addPage();
              yPosition = margin;
            }
            
            pdf.addImage(kpisImgData, 'PNG', margin, yPosition, contentWidth, kpisHeight);
            yPosition += kpisHeight + 10;
            console.log('✅ KPIs capturados exitosamente');
          } catch (kpisError) {
            console.error('❌ Error al capturar KPIs:', kpisError);
          }
        }
        
        // 5. Capturar panel completo de gráficos
        if (this.$refs.chartsPanel && this.showChartsPanel) {
          try {
            console.log('📸 Capturando sección de gráficos...');
            
            // Verificar si necesitamos nueva página
            if (yPosition > pageHeight - 100) {
              pdf.addPage();
              yPosition = margin;
            }
            
            // Capturar todo el panel de gráficos exactamente como en GymSalesTable
            const chartsCanvas = await html2canvas(this.$refs.chartsPanel, {
              allowTaint: true,
              useCORS: true,
              scale: 3,
              backgroundColor: '#ffffff',
              logging: false
            });
            
            const chartsImgData = chartsCanvas.toDataURL('image/png');
            const chartsHeight = (chartsCanvas.height * contentWidth) / chartsCanvas.width;
            
            // Si es muy alto, necesitamos dividirlo en páginas
            let heightLeft = chartsHeight;
            let position = yPosition;
            
            // Primera página
            const firstPageHeight = pageHeight - margin - position;
            if (chartsHeight <= firstPageHeight) {
              // Cabe en una sola página
              pdf.addImage(chartsImgData, 'PNG', margin, position, contentWidth, chartsHeight);
            } else {
              // Necesita múltiples páginas
              pdf.addImage(chartsImgData, 'PNG', margin, position, contentWidth, firstPageHeight, 
                undefined, undefined, 0, 0, chartsCanvas.width, (firstPageHeight * chartsCanvas.width) / contentWidth);
              heightLeft -= firstPageHeight;
              
              // Páginas adicionales
              while (heightLeft > 0) {
                pdf.addPage();
                position = margin;
                const pageContentHeight = pageHeight - (margin * 2);
                const chunkHeight = Math.min(heightLeft, pageContentHeight);
                
                pdf.addImage(
                  chartsImgData, 
                  'PNG', 
                  margin, 
                  position, 
                  contentWidth, 
                  chunkHeight,
                  undefined,
                  undefined,
                  0,
                  ((chartsHeight - heightLeft) * chartsCanvas.width) / contentWidth,
                  chartsCanvas.width,
                  (chunkHeight * chartsCanvas.width) / contentWidth
                );
                
                heightLeft -= chunkHeight;
              }
            }
            
            console.log('✅ Gráficos capturados exitosamente');
          } catch (chartsError) {
            console.error('❌ Error al capturar gráficos:', chartsError);
            throw new Error('Error al capturar la sección de gráficos');
          }
        }
        
        // 6. Footer en todas las páginas
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(8);
          pdf.setFont('helvetica', 'normal');
          
          // Línea separadora
          pdf.setDrawColor(200, 200, 200);
          pdf.line(margin, pageHeight - 10, pageWidth - margin, pageHeight - 10);
          
          // Información del período
          const periodo = this.filters.dateFrom && this.filters.dateTo 
            ? `${this.formatDate(this.filters.dateFrom)} - ${this.formatDate(this.filters.dateTo)}`
            : 'Período completo';
          pdf.text(`Período: ${periodo}`, margin, pageHeight - 5);
          
          // Texto central
          pdf.text('Informe generado desde CentralGym App - https://centralgym.cl', pageWidth / 2, pageHeight - 5, { align: 'center' });
          
          // Numeración de páginas
          pdf.text(`Página ${i} de ${totalPages}`, pageWidth - margin, pageHeight - 5, { align: 'right' });
        }
        
        // 7. Generar nombre de archivo
        const fechaArchivo = this.$moment().format('DD-MM-YYYY_HH-mm-ss');
        const nombreArchivo = `Analisis_Cierres_Caja_${fechaArchivo}.pdf`;
        
        // 8. Descargar PDF
        pdf.save(nombreArchivo);
        
        // 9. Esperar un momento
        await new Promise(resolve => setTimeout(resolve, 500));
        
        console.log('✅ Exportación de gráficos a PDF completada:', nombreArchivo);
        
      } catch (error) {
        console.error('❌ Error al exportar PDF:', error);
      } finally {
        this.isExportingPDF = false;
      }
    },
    
    // Método auxiliar para obtener el rango de fechas consultado
    getRangoFechasConsultado() {
      if (this.filters.dateFrom && this.filters.dateTo) {
        const desde = this.formatDate(this.filters.dateFrom);
        const hasta = this.formatDate(this.filters.dateTo);
        return `Período: ${desde} al ${hasta}`;
      } else if (this.filters.dateFrom) {
        return `Desde: ${this.formatDate(this.filters.dateFrom)}`;
      } else if (this.filters.dateTo) {
        return `Hasta: ${this.formatDate(this.filters.dateTo)}`;
      } else {
        return 'Período: Completo';
      }
    }
  },
  
  computed: {
    recordsInfo() {
      const start = ((this.localPagination.currentPage - 1) * this.localPagination.itemsPerPage) + 1;
      const end = Math.min(start + this.localPagination.itemsPerPage - 1, this.totalRecords);
      return `Mostrando ${start} a ${end} de ${this.totalRecords} registros`;
    },
    
    availablePages() {
      const pages = [];
      const totalPages = this.localPagination.totalPages;
      const currentPage = this.localPagination.currentPage;
      const maxPagesToShow = 5;
      
      if (totalPages <= maxPagesToShow) {
        // Mostrar todas las páginas si son pocas
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        // Lógica para mostrar páginas con elipsis
        if (currentPage <= 3) {
          // Estamos cerca del inicio
          for (let i = 1; i <= 4; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(totalPages);
        } else if (currentPage >= totalPages - 2) {
          // Estamos cerca del final
          pages.push(1);
          pages.push('...');
          for (let i = totalPages - 3; i <= totalPages; i++) {
            pages.push(i);
          }
        } else {
          // Estamos en el medio
          pages.push(1);
          pages.push('...');
          pages.push(currentPage - 1);
          pages.push(currentPage);
          pages.push(currentPage + 1);
          pages.push('...');
          pages.push(totalPages);
        }
      }
      
      return pages.filter(p => p === '...' || (p >= 1 && p <= totalPages));
    },
    
    // Filtros guardados ordenados
    sortedSavedFilters() {
      return this.savedFilters.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    }
  },
  
  mounted() {
    // Cargar sucursales al montar el componente
    this.loadBranchesFromSession();
    
    // Cargar filtros guardados
    this.loadSavedFilters();
  },
  
  beforeDestroy() {
    // Limpiar event listener si el componente se destruye
    if (this.showDetailModal) {
      document.removeEventListener('keydown', this.handleEscapeKey);
    }
  },
  
  watch: {
    metrics: {
      handler(newVal) {
        if (newVal && this.showChartsPanel) {
          this.$nextTick(() => {
            this.renderCharts();
          });
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.table-responsive {
  min-height: 400px;
}

/* Asegurar que todos los contenedores de filtros tengan el mismo ancho */
.filter-field {
  min-width: 0; /* Permite que flexbox reduzca el tamaño si es necesario */
}

/* Asegurar que todos los campos de formulario tengan el mismo ancho */
.filter-field .form-control,
.filter-field .form-select {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  box-sizing: border-box;
}

/* Prevenir que el contenido expanda los select */
.filter-field .form-select {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Estilo específico para el dropdown de sucursales */
.filter-field select.form-select option {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

/* Para pantallas medianas y grandes, asegurar que los campos mantengan el mismo ancho */
@media (min-width: 768px) {
  .row > .col-md-3.filter-field {
    flex: 0 0 25%;
    max-width: 25%;
  }
}

/* Color de fondo permanente para el header */
.card-header.bg-success {
  background-color: #28A745 !important;
  padding: 1rem;
  padding-bottom: 1rem;
}

/* Estilos para los botones de panel - Consistente con otros componentes */
.btn-filter--border {
  border: 2px solid #f8f9fa !important;
  color: #fff !important;
  transition: all 0.2s ease;
}

.btn-filter--border:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: rgba(255, 255, 255, 0.1) !important;
}

/* Botones de panel - Estado normal (gris oscuro con borde blanco) */
.panel-toggle-btn.btn-filter--border {
  background-color: rgba(52, 58, 64, 0.8) !important;
  border-color: rgba(255, 255, 255, 0.8) !important;
  color: #fff !important;
  transition: all 0.3s ease !important;
}

/* Botones de panel - Estado activo (tono más claro) */
.panel-toggle-btn.btn-filter--border.active {
  background-color: rgba(108, 117, 125, 0.9) !important;
  border-color: rgba(255, 255, 255, 1) !important;
  color: #fff !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
}

/* Hover para ambos estados */
.panel-toggle-btn.btn-filter--border:hover {
  background-color: rgba(73, 80, 87, 0.9) !important;
  border-color: rgba(255, 255, 255, 1) !important;
  transform: translateY(-1px);
}

/* Estilos para KPIs */
.icon-shape {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 1.25rem;
}

/* Estilos para gráficos */
.chart-container {
  position: relative;
  min-height: 300px;
}

/* Estilos para filtros guardados */
.saved-filter-card {
  transition: all 0.3s ease;
}

.saved-filter-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Estilos para filtros móviles */
.mobile-filters {
  background-color: #28a745;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1rem;
}

.mobile-filters .form-label {
  color: #fff !important;
  font-weight: 600 !important;
  font-size: 0.875rem !important;
}

.mobile-filters .form-control,
.mobile-filters .form-select {
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #495057;
}

.mobile-filters .form-control:focus,
.mobile-filters .form-select:focus {
  background-color: #fff;
  border-color: #fff;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.25);
}

/* Estilos responsive para móviles */
@media (max-width: 767.98px) {
  /* Tamaño consistente para todos los botones móviles */
  .mobile-filters .btn-group .btn,
  .mobile-btn-consistent {
    font-size: 0.75rem !important;
    padding: 0.375rem 0.5rem !important;
    height: 2.25rem !important;
    line-height: 1.2 !important;
    border-radius: 0.25rem !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  
  /* Ajustes específicos para botones de panel en móvil */
  .mobile-filters .panel-toggle-btn.btn-filter--border {
    background-color: #6c757d !important;
    border: 2px solid #fff !important;
    color: #fff !important;
  }
  
  .mobile-filters .panel-toggle-btn.btn-filter--border:hover {
    background-color: #5a6268 !important;
  }
  
  .mobile-filters .panel-toggle-btn.btn-filter--border.active {
    background-color: #5a6268 !important;
    border: 2px solid #fff !important;
    color: #fff !important;
  }
  
  /* Botones de acción en móvil */
  .mobile-filters .btn-info {
    background-color: #17a2b8 !important;
    border: 2px solid #17a2b8 !important;
    color: #fff !important;
  }
  
  .mobile-filters .btn-success {
    background-color: #28a745 !important;
    border: 2px solid #28a745 !important;
    color: #fff !important;
  }
  
  /* Corrección para campos de formulario móviles */
  .mobile-filters .row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  
  .mobile-filters .col-6 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }
  
  .mobile-filters .col-6.pe-2 {
    padding-right: 0.25rem !important;
  }
  
  .mobile-filters .col-6.ps-2 {
    padding-left: 0.25rem !important;
  }
  
  /* Asegurar que los selects no se salgan del contenedor */
  .mobile-filters .form-select {
    max-width: 100% !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }
  
  /* Espaciado consistente para iconos en botones móviles */
  .mobile-btn-consistent .fas,
  .mobile-btn-consistent .fa {
    margin-right: 0.25rem !important;
    font-size: 0.75rem !important;
  }
}

/* Estilos para filtros guardados */
.saved-filter-card {
  transition: all 0.3s ease;
  cursor: pointer;
  border-color: #ddd !important;
}

.saved-filter-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-color: #66C4DE !important;
}

.saved-filter-card .card-header {
  font-size: 0.875rem;
}

.saved-filter-card .card-body {
  font-size: 0.875rem;
}

.badge-sm {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  font-weight: normal;
  letter-spacing: 0.3px;
}

.filter-details {
  min-height: 60px;
}

.badge-container {
  min-height: 24px;
}

.date-range-info {
  color: #6c757d;
}

.creation-date {
  color: #6c757d;
  font-style: italic;
}

/* Fondo del panel de filtros guardados */
.card[v-if*="showSavedFilters"] .card-body {
  background-color: #ffffff;
}

/* Estilos del modal */
#saveFilterModalCashClosure .modal-header {
  background-color: #66C4DE !important;
  border-bottom: 1px solid #66C4DE;
}

#saveFilterModalCashClosure .modal-body {
  padding: 1.5rem;
}

#saveFilterModalCashClosure .alert {
  margin-bottom: 0;
}

#saveFilterModalCashClosure .alert ul {
  margin-bottom: 0;
  padding-left: 1.5rem;
}

#saveFilterModalCashClosure .alert li {
  margin-bottom: 0.25rem;
}

/* Animación para empty state */
.empty-state {
  animation: fadeIn 0.5s ease-in;
}

/* Alert de instrucciones */
.alert-info[style*="#E3F2FD"] {
  border-radius: 8px;
  border-width: 2px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Efecto hover para botón turquesa */
.btn[style*="#66C4DE"]:hover {
  background-color: #4FB3CE !important;
  border-color: #4FB3CE !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Estilos para modal con Vue */
.modal.show {
  display: block !important;
}

.modal-backdrop.show {
  opacity: 0.5;
}

/* Prevenir scroll cuando el modal está abierto */
body.modal-open {
  overflow: hidden;
  padding-right: 17px;
}

/* Estilos para la columna CAJA */
.caja-column {
  white-space: nowrap !important;
  min-width: 80px !important;
  width: auto !important;
}

/* Prevenir que el texto de la columna CAJA se corte o baje */
th.caja-column,
td.caja-column {
  white-space: nowrap !important;
  overflow: visible !important;
  text-overflow: unset !important;
}

/* Asegurar que la tabla no comprima demasiado la columna CAJA */
.table {
  table-layout: auto !important;
}

/* Dar un poco más de padding a la columna CAJA para mejor legibilidad */
td.caja-column {
  padding-right: 1rem !important;
}

/* Estilos para el modal de detalle */
#cashClosureDetailModal .modal-dialog {
  max-width: 1200px;
}

#cashClosureDetailModal .modal-dialog-scrollable .modal-body {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

#cashClosureDetailModal .modal-header {
  background-color: #007bff !important;
  border-bottom: none;
  padding: 1rem 1.5rem;
  min-height: 60px;
}

#cashClosureDetailModal .modal-title {
  font-size: 1.25rem;
  font-weight: 600;
}



/* Columna de método de pago sin wrap */
#cashClosureDetailModal .payment-method-column {
  white-space: nowrap !important;
  min-width: 140px !important;
}

/* Footer del modal */
#cashClosureDetailModal .modal-footer {
  padding: 1rem 0;
  border-top: 1px solid #e9ecef;
}

#cashClosureDetailModal .modal-footer .btn {
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

#cashClosureDetailModal .modal-footer .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

/* Estilo para la nota informativa */
#cashClosureDetailModal .alert-info {
  background-color: #e3f2fd;
  border-color: #bbdefb;
  color: #0d47a1;
  border-radius: 8px;
}

#cashClosureDetailModal .alert-info small {
  font-size: 0.875rem;
  line-height: 1.5;
}

/* Asegurar espaciado del ícono de información */
#cashClosureDetailModal .alert-info .fa-info-circle {
  font-size: 1.25rem;
}

/* Estilos para el botón EXPORTAR PDF */
.btn-export-pdf {
  background-color: #dc3545 !important;
  border-color: #dc3545 !important;
  color: #fff !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-export-pdf:hover:not(:disabled) {
  background-color: #c82333 !important;
  border-color: #bd2130 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.4) !important;
}

.btn-export-pdf:active:not(:disabled) {
  background-color: #bd2130 !important;
  border-color: #b21f2d !important;
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(220, 53, 69, 0.3) !important;
}

.btn-export-pdf:disabled {
  background-color: #dc3545 !important;
  border-color: #dc3545 !important;
  opacity: 0.6 !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
}

.btn-export-pdf:focus {
  outline: none !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25), 0 2px 4px rgba(220, 53, 69, 0.3) !important;
}

/* Animación del ícono PDF */
.btn-export-pdf .fa-file-pdf {
  transition: transform 0.3s ease;
}

.btn-export-pdf:hover:not(:disabled) .fa-file-pdf {
  transform: scale(1.1);
}

#cashClosureDetailModal .card {
  border-radius: 8px;
  border: 1px solid rgba(0,0,0,0.08);
}

#cashClosureDetailModal .card-header {
  border-radius: 8px 8px 0 0;
  padding: 0.75rem 1.25rem;
  font-weight: 600;
  background-color: #f8f9fa !important;
  border-bottom: 1px solid #e9ecef;
}

#cashClosureDetailModal .info-item label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}

#cashClosureDetailModal .info-item .fw-bold {
  font-size: 0.9375rem;
}

#cashClosureDetailModal .table {
  margin-bottom: 0;
}

#cashClosureDetailModal .table thead th {
  background-color: #f8f9fa;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #dee2e6;
  padding: 0.75rem;
}

#cashClosureDetailModal .table tbody td {
  padding: 0.75rem;
  vertical-align: middle;
}

#cashClosureDetailModal .table-active {
  background-color: #f8f9fa !important;
  font-weight: 700;
}

#cashClosureDetailModal .badge {
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 6px;
}

/* Cards internos */
#cashClosureDetailModal .card .bg-light,
#cashClosureDetailModal .card .bg-success,
#cashClosureDetailModal .card .bg-danger {
  border-radius: 8px !important;
}

/* Animación para el modal de detalle */
#cashClosureDetailModal.show {
  animation: slideInFromTop 0.3s ease-out;
}

@keyframes slideInFromTop {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Estilos responsivos para el modal de detalle */
@media (max-width: 767.98px) {
  #cashClosureDetailModal .modal-dialog {
    margin: 0.5rem;
    max-width: calc(100% - 1rem);
  }
  
  #cashClosureDetailModal .modal-content {
    max-height: calc(100vh - 1rem);
  }
  
  #cashClosureDetailModal .modal-header {
    padding: 1rem;
  }
  
  #cashClosureDetailModal .modal-title {
    font-size: 1.125rem;
  }
  
  #cashClosureDetailModal .modal-body {
    padding: 1rem;
  }
  
  #cashClosureDetailModal .card {
    margin-bottom: 1rem !important;
  }
  
  #cashClosureDetailModal .card-header {
    padding: 0.75rem 1rem;
  }
  
  #cashClosureDetailModal .card-body {
    padding: 1rem;
  }
  
  #cashClosureDetailModal .row > .col-md-6 {
    margin-bottom: 0.5rem;
  }
  
  #cashClosureDetailModal .info-item {
    margin-bottom: 1rem !important;
  }
  
  #cashClosureDetailModal .table {
    font-size: 0.8125rem;
  }
  
  #cashClosureDetailModal .table thead th {
    font-size: 0.75rem;
    padding: 0.5rem;
  }
  
  #cashClosureDetailModal .table tbody td {
    padding: 0.5rem;
    font-size: 0.8125rem;
  }
  
  /* Hacer la tabla scrollable horizontalmente en móvil */
  #cashClosureDetailModal .table-responsive {
    -webkit-overflow-scrolling: touch;
    margin-bottom: 1rem;
  }
  
  /* Footer en móvil */
  #cashClosureDetailModal .modal-footer {
    padding: 0.75rem 0;
  }
  
  #cashClosureDetailModal .modal-footer .container-fluid {
    padding: 0 1rem;
  }
  
  #cashClosureDetailModal .modal-footer .btn {
    font-size: 0.9375rem;
    padding: 0.75rem 1rem;
  }
  
  /* Cards de resumen en móvil */
  #cashClosureDetailModal .col-md-6 .card {
    margin-bottom: 0.75rem;
  }
  
  /* Badges en móvil */
  #cashClosureDetailModal .badge {
    font-size: 0.8125rem;
    padding: 0.375rem 0.625rem;
  }
  
  /* Alert en móvil */
  #cashClosureDetailModal .alert {
    padding: 0.75rem;
    font-size: 0.8125rem;
  }
  
  #cashClosureDetailModal .alert small {
    font-size: 0.8125rem;
  }
}

</style>